<template>
  <div
    v-loading="isDataLoadingComputed"
    class="affiliate-info"
  >
    <!-- <AffiliateRotationGroupsPopup
      v-if="(currentAcl.affiliates_rotation_groups_edit === 'allow' && currentAcl.service_rotation_groups_view === 'allow' ) || adminAcl.is_superuser"
      :is-open="isOpenRotationGroupsPopup"
      :inital-data="rotationGroups"
      @close="closeRotationGroupsPopup"
      @save="updateRotationGroupsForAffiliate"
    /> -->
    <EditPublicProfile
      :id="id"
      ref="editPublicProfile"
      @update-affiliate="fetchAffiliateData({ isSilent: true })"
    />
    <UiConfirm
      ref="editBls"
      :width="480"
      :type="editBls.type"
      :action="editBls.action"
      :action-name="$t('affiliates.confirm.edit_balance')"
      :action-fa-icon="editBls.actionFaIcon"
      :action-disabled="balance.sum === '' || balance.note === ''"
      class="confirm-edit-balance"
      @close="cancelBls"
      @save="saveBls"
    >
      <template v-slot:title>
        <div v-html="editBls.title" />
      </template>

      <div
        class="body__msg"
        v-html="editBls.msg"
      />
      <div>
        <div class="body__first-line">
          <div class="body__radio-wr">
            <UiTabs
              v-model="balance.operation"
              :list="balanceOperations"
              :label="$t('affiliates.affiliatesInfo.operation')"
              size="big"
            />
          </div>
          <UiInput
            v-model="balance.sum"
            :placeholder="$t('affiliates.affiliatesInfo.inp_sum')"
            :label="$t('affiliates.affiliatesInfo.sum')"
            :error="errors.amount"
            class="body__input edit-balance"
            :post-text="currencyPrefix"
            size="big"
          />
        </div>
        <UiCheckbox
          v-model="balance.reflect_in_statistics"
          :label="$t('affiliates.affiliatesInfo.reflect_in_statistics')"
          class="t:mb-16"
        />
        <UiTextarea
          v-model="balance.note"
          :label="$t('affiliates.affiliatesInfo.note')"
          :placeholder="$t('affiliates.affiliatesInfo.note_about_user')"
          :autosize="{ minRows: 4, maxRows: 7}"
          :maxlength="225"
          resize="vertical"
        />
      </div>
    </UiConfirm>
    <UiConfirm
      ref="confirm"
      :width="480"
      :type="confirmType"
      :action-name="actionName"
      :action="confirmAction"
      :action-icon="actionIcon"
      :action-fa-icon="actionFaIcon"
      :action-disabled="isLoading"
      :has-close-btn="confirmDangerButton"
      @save="onConfirm"
      @close="confirmClose"
    >
      <template v-slot:title>
        <div v-html="confirmTitle" />
      </template>

      <div class="body__wrap">
        <i
          v-if="confirmAction === 'Approve'"
          :class="confirmType"
          class="fas fa-check"
        />
        <i
          v-else-if="confirmAction === 'createPayment'"
          :class="confirmType"
          class="fas fa-money-bill-wave-alt"
        />
        <i
          v-else-if="confirmAction === 'confirmPayment' && infoCreatePayment.payment_created"
          :class="confirmType"
          class="fas fa-check"
        />
        <i
          v-else-if="confirmAction === 'confirmPayment' && !infoCreatePayment.payment_created"
          :class="confirmType"
          class="fas fa-exclamation-triangle t:mr-12"
        />
        <i
          v-else-if="confirmAction === 'Decline'"
          :class="confirmType"
          class="fas fa-times"
        />
        <i
          v-else-if="confirmAction === 'Decline w/'"
          :class="confirmType"
          class="fas fa-bell"
        />
        <i
          v-else-if="confirmAction === 'Block'"
          :class="confirmType"
          class="fas fa-lock"
        />
        <i
          v-else-if="confirmAction === 'Unblock'"
          :class="confirmType"
          class="fas fa-unlock"
        />
        <i
          v-else-if="confirmAction === 'deleteNote'"
          :class="confirmType"
          class="fas fa-trash-alt"
        />
        <i
          v-else-if="confirmAction === 'deletePublicProfile'"
          :class="confirmType"
          class="fas fa-times"
        />
        <i
          v-else-if="confirmAction === 'skipKyc'"
          :class="confirmType"
          class="fas fa-arrow-right-long-to-line"
        />
        <i
          v-else
          :class="confirmType"
          class="fas fa-exclamation-triangle t:mr-12"
        />
        <div
          class="body__msg t:ml-12"
          v-html="confirmMsg"
        />
      </div>
    </UiConfirm>
    <UiConfirm
      ref="confirmEditPayment"
      :width="480"
      :type="confirmEditPayment.type"
      :action-name="$t('affiliates.confirm.save')"
      :action="confirmEditPayment.action"
      :action-fa-icon="'check'"
      class="confirm-edit-payment"
      @close="cancelPayment"
      @save="savePayment"
    >
      <template v-slot:title>
        <div v-html="confirmEditPayment.title" />
      </template>

      <div class="t:space-y-16">
        <CardTitle
          :title="$t(`affiliates.cardView.info.payments_enabled`)"
        >
          <UiSwitch
            v-model="payment.payments_enabled"
          />
        </CardTitle>
        <div
          class="body__msg"
          v-html="confirmEditPayment.msg"
        />
        <div class="t:flex t:space-x-16">
          <UiSelectElement
            v-model="payment.site_payment_method_id"
            :label="$t('affiliates.cardView.info.paymentMethod')"
            :placeholder="$t('affiliates.cardView.info.paymentMethod')"
            :list="paymentMethodsByCurrencyCode"
            size="big"
            filterable
            ellipsis
            clearable
            :error="errors.site_payment_method_id"
            @change="payment.payment_wallet = null"
          />
          <UiSelectElement
            v-model="payment.payments_net"
            :label="$t('affiliates.cardView.info.paymentPeriod')"
            :placeholder="$t('affiliates.cardView.info.paymentPeriod')"
            :list="pPaymentPeriods"
            size="big"
            @change="payment.messenger_id = ''"
          />
        </div>
        <UiInput
          v-model="payment.payment_wallet"
          :disabled="!payment.site_payment_method_id"
          :placeholder="placeholderWallet || ''"
          :label="$t(`affiliates.cardView.info.wallet`)"
          :error="errors.payment_wallet"
          class="wallet-p"
          autosize
          size="big"
        />
        <UiCheckbox
          v-model="payment.payments_negative_carryover"
          :label="$t(`affiliates.cardView.info.negative_carryover`)"
          class="t:mb-8"
        />
        <UiTextarea
          v-model="payment.reason"
          :label="$t('affiliates.affiliatesInfo.reason')"
          :maxlength="225"
          :autosize="{ minRows: 4, maxRows: 7}"
          :placeholder="$t('affiliates.affiliatesInfo.reason')"
        />
      </div>
    </UiConfirm>
    <UiConfirm
      ref="editCurrency"
      :width="480"
      type="success"
      action-fa-icon="check"
      :action-name="$t('crm.buttons.save')"
      class="confirm-edit-payment"
      @save="saveCurrency"
    >
      <template v-slot:title>
        <div>
          {{ $t('affiliates.affiliatesInfo.currency.popup.title') }}
        </div>
      </template>

      <div class="body__wrap">
        <div class="select-wrap">
          <div class="select-block select-block__full">
            <UiSelectElement
              v-model="currentCurrency"
              :label="$t('affiliates.affiliatesInfo.currency.label')"
              :placeholder="$t('affiliates.cardView.info.paymentMethod')"
              :list="currencyOptions"
              option-value-param="code"
              filterable
              size="big"
              :error="errors.country_code"
            />
          </div>
        </div>
      </div>
    </UiConfirm>
    <UiConfirm
      ref="confirmEditLimits"
      :width="480"
      :type="confirmEditLimits.type"
      :action-name="$t('affiliates.confirm.save')"
      :action="confirmEditLimits.action"
      :action-fa-icon="'check'"
      class="confirm-edit-payment"
      @close="cancelLimits"
      @save="saveLimits"
    >
      <template v-slot:title>
        <div v-html="confirmEditLimits.title" />
      </template>

      <div class="body__wrap">
        <UiInput
          v-model="limits.max_api_keys"
          :placeholder="$t(`affiliates.affiliatesInfo.max_api_keys`)"
          :label="$t(`affiliates.affiliatesInfo.max_api_keys`)"
          :error="errors.max_api_keys"
          autosize
          size="big"
          @change="preventLimitsSymbol"
        />
        <div class="promo-codes-levels t:mt-16">
          <div class="t:flex t:justify-between">
            <UiLabel
              class="t:!mb-0"
              :label="$t('affiliates.affiliatesInfo.max_promo_codes')"
              bold
            />
            <UiButton
              icon="plus"
              no-border
              :icon-size="12"
              class="t:!p-0"
              @click="addAffiliatePromoCodeLevel"
            >
              {{ $t('affiliates.offer_popup.add_level') }}
            </UiButton>
          </div>
          <div
            v-if="limits.max_promo_codes_levels?.length"
            class="t:flex t:flex-col t:mt-8"
          >
            <div
              v-for="(item, index) in limits.max_promo_codes_levels"
              :key="index"
              class="t:flex t:items-center t:gap-8 t:mt-8"
            >
              <UiInput
                v-model.number="item.ftd_count"
                pre-icon="greater-than-equal"
                class="promo-codes-levels__input"
                :class="{ 'promo-codes-levels__input_readonly': index === 0 }"
                post-text="FTD"
                :disabled="index === 0"
                error-tooltip
                :error="getError(['max_promo_codes_levels', index, 'ftd_count'])"
                @change="preventLimitsSymbol"
              />
              <hr class="promo-codes-levels__divider">
              <UiInput
                v-model.number="item.max_amount"
                class="promo-codes-levels__input"
                error-tooltip
                :error="getError(['max_promo_codes_levels', index, 'max_amount'])"
                @change="preventLimitsSymbol"
              />
              <UiIcon
                size="14px"
                class="t:cursor-pointer"
                name="times"
                color="var(--text-negative)"
                :disabled="index === 0 && limits.max_promo_codes_levels.length > 1"
                @click="removeAffiliatePromoCodeLevel(index)"
              />
            </div>
          </div>
        </div>

        <UiInput
          v-model="limits.max_traffic_sources"
          class="t:mt-16"
          :placeholder="$t(`affiliates.affiliatesInfo.max_traffic_sources`)"
          :label="$t(`affiliates.affiliatesInfo.max_traffic_sources`)"
          :error="errors.max_traffic_sources"
          autosize
          size="big"
          @change="preventLimitsSymbol"
        />

        <UiInput
          v-model="limits.max_postbacks_per_traffic_source"
          class="t:mt-16"
          :placeholder="$t(`affiliates.affiliatesInfo.max_postbacks_per_traffic_source`)"
          :label="$t(`affiliates.affiliatesInfo.max_postbacks_per_traffic_source`)"
          :error="errors.max_postbacks_per_traffic_source"
          autosize
          size="big"
          @change="preventLimitsSymbol"
        />

        <UiInput
          v-model="limits.max_tags_per_traffic_source"
          class="t:mt-16"
          :placeholder="$t(`affiliates.affiliatesInfo.max_tags_per_traffic_source`)"
          :label="$t(`affiliates.affiliatesInfo.max_tags_per_traffic_source`)"
          :error="errors.max_tags_per_traffic_source"
          autosize
          size="big"
          @change="preventLimitsSymbol"
        />

        <UiSelectElement
          v-model="limits.allow_promo_code_create_or_edit"
          class="t:mt-16"
          :label="$t('settings.systemSettings.createPromoCodes')"
          :placeholder="$t('settings.systemSettings.createPromoCodes')"
          :list="promoCodesOption"
          size="big"
          :error="errors.allow_promo_code_create_or_edit"
        />
      </div>
    </UiConfirm>
    <UiConfirm
      ref="changeNotificationsStatus"
      :width="480"
      type="success"
      :action-name="$t('affiliates.confirm.save')"
      action-fa-icon="check"
      class="change-notifications-status"
      @close="cancelNotificationsStatus"
      @save="saveNotificationsStatus"
    >
      <template v-slot:title>
        <div>{{ $t('affiliates.affiliate_notifications.popup.title') }}</div>
      </template>

      <div class="t:space-y-16">
        <CardTitle
          :title="$t('affiliates.affiliate_notifications.popup.notifications_enabled')"
        >
          <UiSwitch
            v-model="notification.service_domain_changes_notifications_enabled"
          />
        </CardTitle>
        <UiSelectElement
          v-model="notification.service_domain_changes_notifications_channel"
          :label="$t('affiliates.affiliate_notifications.popup.select_label')"
          :list="notificationsType"
          size="big"
          :disabled="!notification.service_domain_changes_notifications_enabled"
          :error="errors.allow_promo_code_create_or_edit"
        />
      </div>
    </UiConfirm>
    <UiConfirm
      ref="confirmChangeMail"
      :width="480"
      :action-name="$t(`affiliates.cardView.info.change_mail`)"
      type="success"
      action-fa-icon="check"
      class="confirm-edit-payment"
      @save="changeEmail"
    >
      <template v-slot:title>
        <div v-html="confirmChangeMail.title" />
      </template>

      <div class="body__wrap">
        <div class="select-wrap">
          <div class="select-block select-block__full">
            <UiInput
              v-model="newEmail"
              :placeholder="$t(`affiliates.confirm.change_email_placeholder`)"
              :label="$t(`affiliates.confirm.change_email_label`)"
              :error="errors.email"
              size="big"
              autosize
            />
          </div>
        </div>
      </div>
    </UiConfirm>
    <UiConfirm
      ref="confirmEditInfo"
      :width="480"
      :type="confirmEditInfo.type"
      :action-name="$t('affiliates.confirm.save')"
      :action="confirmEditInfo.action"
      :action-icon="actionIcon"
      :action-fa-icon="actionFaIcon"
      class="confirm-edit-payment"
      @close="cancelInfo"
      @save="saveInfo"
    >
      <template v-slot:title>
        <div v-html="confirmEditInfo.title" />
      </template>

      <div class="body__wrap">
        <div class="select-wrap">
          <div class="select-block">
            <ElTooltip
              :content="kycVerifiedTooltip"
              placement="bottom"
              :show-after="300"
              :disabled="!isKycFieldLocked('first_name')"
              popper-class="affiliate-info__kyc-tooltip"
              :teleported="true"
            >
              <div class="t:w-full">
                <UiInput
                  v-model="popupInfo.first_name"
                  :placeholder="$t(`affiliates.cardView.info.fname`)"
                  :label="$t(`affiliates.cardView.info.fname`)"
                  :error="errors.first_name"
                  :readonly="isKycFieldLocked('first_name')"
                  size="big"
                  autosize
                />
              </div>
            </ElTooltip>
          </div>
          <div class="select-block">
            <ElTooltip
              :content="kycVerifiedTooltip"
              placement="bottom"
              :show-after="300"
              :disabled="!isKycFieldLocked('last_name')"
              popper-class="affiliate-info__kyc-tooltip"
              :teleported="true"
            >
              <div class="t:w-full">
                <UiInput
                  v-model="popupInfo.last_name"
                  :placeholder="$t(`affiliates.cardView.info.surname`)"
                  :label="$t(`affiliates.cardView.info.surname`)"
                  :error="errors.last_name"
                  :readonly="isKycFieldLocked('last_name')"
                  size="big"
                  autosize
                />
              </div>
            </ElTooltip>
          </div>
        </div>
        <div class="select-wrap">
          <div class="select-block select-block__full">
            <ElTooltip
              :content="kycVerifiedTooltip"
              placement="bottom"
              :show-after="300"
              :disabled="!isKycFieldLocked('date_of_birth')"
              popper-class="affiliate-info__kyc-tooltip"
              :teleported="true"
            >
              <div class="t:w-full">
                <UiDatePicker
                  v-model="popupInfo.date_of_birth"
                  class="t:w-full"
                  :label="$t(`affiliates.cardView.info.birthDay`)"
                  :placeholder="$t(`affiliates.cardView.info.birthDay`)"
                  min-date="01-01-1900"
                  :max-date="disabledDate"
                  :multi-calendars="false"
                  :range="false"
                  size="big"
                  auto-apply
                  :always-clearable="false"
                  teleport
                  :error="errors?.date_of_birth"
                  :is-readonly="isKycFieldLocked('date_of_birth')"
                />
              </div>
            </ElTooltip>
          </div>
        </div>
        <div class="popup-line" />
        <div class="select-wrap">
          <ElTooltip
            :content="kycVerifiedTooltip"
            placement="bottom"
            :show-after="300"
            :disabled="!isKycFieldLocked('phone_number')"
            popper-class="affiliate-info__kyc-tooltip"
            :teleported="true"
          >
            <div class="t:w-full">
              <UiInput
                v-model="popupInfo.phone_number"
                input-mask="+###############"
                :placeholder="$t(`affiliates.cardView.info.phone`)"
                :label="$t(`affiliates.cardView.info.phone`)"
                :error="errors.phone_number"
                :readonly="isKycFieldLocked('phone_number')"
                size="big"
                autosize
              />
            </div>
          </ElTooltip>
        </div>

        <div class="select-wrap">
          <div class="select-block">
            <UiSelectElement
              v-model="popupInfo.messenger"
              :label="$t('affiliates.cardView.info.messenger')"
              :placeholder="$t('affiliates.cardView.info.messenger')"
              :list="messengersInfo"
              size="big"
              @change="popupInfo.messenger_id = ''"
            />
          </div>
          <div class="select-block">
            <UiInput
              v-model="popupInfo.messenger_id"
              :placeholder="placeholderMessenger"
              :label="$t(`affiliates.cardView.info.msgid`)"
              :error="errors.messenger_id"
              size="big"
              autosize
            />
          </div>
        </div>
        <div class="popup-line" />
        <div class="select-wrap">
          <div class="select-block">
            <ElTooltip
              :content="kycVerifiedTooltip"
              placement="bottom"
              :show-after="300"
              :disabled="!isKycFieldLocked('country_code')"
              popper-class="affiliate-info__kyc-tooltip"
              :teleported="true"
            >
              <div class="t:w-full">
                <UiSelectElement
                  v-model="popupInfo.country_code"
                  :readonly="isKycFieldLocked('country_code')"
                  :label="$t('affiliates.cardView.info.country')"
                  :placeholder="$t('affiliates.cardView.info.country')"
                  :list="countries"
                  option-value-param="code"
                  size="big"
                  filterable
                />
              </div>
            </ElTooltip>
          </div>
          <div class="select-block">
            <UiInput
              v-model="popupInfo.city"
              :placeholder="$t(`affiliates.cardView.info.city`)"
              :label="$t(`affiliates.cardView.info.city`)"
              :error="errors.city"
              size="big"
              autosize
            />
          </div>
        </div>
        <div class="select-wrap">
          <div class="select-block">
            <UiInput
              v-model="popupInfo.postal_code"
              :placeholder="$t(`affiliates.cardView.info.postal_code`)"
              :label="$t(`affiliates.cardView.info.postal_code`)"
              :error="errors.postal_code"
              size="big"
              autosize
            />
          </div>
          <div class="select-block">
            <UiInput
              v-model="popupInfo.address"
              :placeholder="$t(`affiliates.cardView.info.address`)"
              :label="$t(`affiliates.cardView.info.address`)"
              :error="errors.address"
              size="big"
              autosize
            />
          </div>
        </div>
      </div>
    </UiConfirm>
    <UiConfirm
      ref="editSiteUrl"
      :width="480"
      :type="editSiteUrl.type"
      :action-name="$t('affiliates.confirm.save')"
      :action="editSiteUrl.action"
      :action-icon="actionIcon"
      :action-fa-icon="actionFaIcon"
      class="edit-sites-url"
      @close="cancelSiteUrl"
      @save="savelSiteUrl"
    >
      <template v-slot:title>
        <div v-html="editSiteUrl.title" />
      </template>

      <div
        class="body__msg"
        v-html="editSiteUrl.msg"
      />
      <div class="body__wrap">
        <div class="sites-title">
          {{ $t(`affiliates.cardView.info.site_urls`) }}
        </div>
        <div class="site-wrapper">
          <div
            v-for="(item, index) in popupInfo.site_url"
            :key="index"
            class="site-row"
          >
            <UiInput
              v-model="popupInfo.site_url[index]"
              :placeholder="$t(`affiliates.cardView.info.site_urls`)"
              class="site-input"
            />
            <UiButton
              type="negative"
              icon="times"
              class="site-del"
              @click="removeSite(index)"
            />
          </div>
        </div>
        <UiButton
          icon="plus"
          @click="addSite"
        >
          {{ $t(`affiliates.cardView.info.add_url`) }}
        </UiButton>
      </div>
    </UiConfirm>
    <ResetPasswordPopup
      :id="id"
      :is-open="isResetOpen"
      :email="info.email || ''"
      @close="isResetOpen = false"
    />
    <!--    <ConfirmPopup-->
    <!--      v-show="isConfirmOpen"-->
    <!--      :on-confirm="onConfirm"-->
    <!--      :action-title="confirmAction"-->
    <!--      :is-open="isConfirmOpen"-->
    <!--      @close="isConfirmOpen = false"-->
    <!--    >-->
    <!--      {{ confirmMsg }}-->
    <!--    </ConfirmPopup>-->
    <AffiliateSubPopupTemporary
      v-show="isPinOpen"
      ref="subpin"
      :is-open="isPinOpen"
      :affiliate-data="info"
      aff-info="aff"
      @confirm="confirmPin"
      @close="isPinOpen = false"
    />
    <MonitoringPopup
      v-model:monitoring-info="monitoringInfo"
      :is-open="isMonitoringPopupOpen"
      :affiliate-id="id"
      @close="isMonitoringPopupOpen = false"
    />
    <div class="wrapper">
      <div
        v-if="isShowButtons"
        class="toolbar tools"
      >
        <div
          v-if="info.account_status === 'pending'"
          class="btns"
        >
          <UiButton
            v-if="isEditStatus && hasPermission('affiliates_can_approve')"
            filled
            icon="check"
            class="action-btn"
            @click="approveAffiliateHandler"
          >
            {{ $t('affiliates.cardView.toolbar.btns.approve') }}
          </UiButton>
          <UiButton
            v-if="canOpenCreatePayment"
            icon="money-bill-wave-alt"
            class="action-btn"
            @click="createPayment"
          >
            {{ $t('affiliates.cardView.toolbar.btns.create_payment') }}
          </UiButton>
          <UiButton
            v-if="!info.email_verified && isEditStatus"
            icon="check"
            filled
            class="action-btn"
            @click="activateAffiliateHandler"
          >
            {{ $t('affiliates.cardView.toolbar.btns.activate_manual') }}
          </UiButton>
          <UiButton
            v-if="canSkipKyc"
            icon="arrow-right-long-to-line"
            class="action-btn"
            @click="skipKycHandler"
          >
            {{ $t('affiliates.cardView.toolbar.btns.skip_kyc') }}
          </UiButton>
          <UiButton
            v-else-if="showAskForKycButton"
            icon="address-card"
            class="action-btn"
            :disabled="isKycActionDisabled"
            @click="askForKycHandler"
          >
            {{ $t('affiliates.cardView.toolbar.btns.ask_kyc') }}
          </UiButton>
          <UiButton
            icon="face-viewfinder"
            class="action-btn"
            :type="monitoringInfo ? 'negative' : 'positive'"
            @click="monitoringInfo ? handleStopMonitoredClick() : handleMonitoredClick()"
          >
            {{ monitoringInfo ? $t('affiliates.monitored.stop_monitoring') : $t('affiliates.monitored.start_monitoring') }}
          </UiButton>
          <UiButton
            v-if="isEditStatus && hasPermission('affiliates_can_decline')"
            icon="bell"
            type="negative"
            class="action-btn"
            @click="declineAffiliateHandler(true)"
          >
            {{ $t('affiliates.cardView.toolbar.btns.note_decline') }}
          </UiButton>
          <UiButton
            v-if="isEditStatus && hasPermission('affiliates_can_decline')"
            icon="times"
            type="negative"
            filled
            class="action-btn"
            @click="declineAffiliateHandler(false)"
          >
            {{ $t('affiliates.cardView.toolbar.btns.decline') }}
          </UiButton>
        </div>
        <div
          v-else-if="info.account_status === 'rejected'"
          class="btns"
        >
          <UiButton
            v-if="isEditStatus && hasPermission('affiliates_can_revoke')"
            filled
            icon="eye"
            class="action-btn"
            @click="revokeAffiliateHandler"
          >
            {{ $t('affiliates.cardView.toolbar.btns.revoke') }}
          </UiButton>
          <UiButton
            v-if="canOpenCreatePayment"
            icon="money-bill-wave-alt"
            class="action-btn"
            @click="createPayment"
          >
            {{ $t('affiliates.cardView.toolbar.btns.create_payment') }}
          </UiButton>
          <a
            v-if="isViewReports"
            :href="affiliateStatisticSupported ? reportParam : undefined"
            class="login-link"
            @click.prevent="() => {
              affiliateStatisticSupported ? $router.push(reportParam) : undefined
            }"
          >
            <UiButton
              icon="chart-bar"
              class="action-btn el-dropdown-link"
              :disabled="!affiliateStatisticSupported"
            >{{ $t('affiliates.cardView.toolbar.btns.statistics') }}</UiButton>
          </a>
          <UiButton
            v-if="!info.email_verified && isEditStatus"
            icon="check"
            filled
            class="action-btn"
            @click="activateAffiliateHandler"
          >
            {{ $t('affiliates.cardView.toolbar.btns.activate_manual') }}
          </UiButton>
          <UiButton
            v-if="canSkipKyc"
            icon="arrow-right-long-to-line"
            class="action-btn"
            @click="skipKycHandler"
          >
            {{ $t('affiliates.cardView.toolbar.btns.skip_kyc') }}
          </UiButton>
          <UiButton
            v-else-if="showAskForKycButton"
            icon="address-card"
            class="action-btn"
            :disabled="isKycActionDisabled"
            @click="askForKycHandler"
          >
            {{ $t('affiliates.cardView.toolbar.btns.ask_kyc') }}
          </UiButton>
          <UiButton
            icon="face-viewfinder"
            class="action-btn"
            :type="monitoringInfo ? 'negative' : 'positive'"
            @click="monitoringInfo ? handleStopMonitoredClick() : handleMonitoredClick()"
          >
            {{ monitoringInfo ? $t('affiliates.monitored.stop_monitoring') : $t('affiliates.monitored.start_monitoring') }}
          </UiButton>
        </div>
        <div v-else>
          <div
            class="btns"
          >
            <UiButton
              v-if="!info.email_verified && isEditStatus"
              icon="check"
              filled
              class="action-btn"
              @click="activateAffiliateHandler"
            >
              {{ $t('affiliates.cardView.toolbar.btns.activate_manual') }}
            </UiButton>
            <UiButton
              v-if="isEditPass && hasPermission('affiliates_password_edit')"
              icon="key"
              class="action-btn first-btn"
              @click="resetPasswordAffiliate"
            >
              {{ $t('affiliates.cardView.toolbar.btns.reset') }}
            </UiButton>
            <UiButton
              v-if="info.google2fa_enabled && isResetTotp"
              icon="shield-check"
              class="action-btn first-btn"
              @click="resetTotp"
            >
              {{ $t('affiliates.cardView.toolbar.btns.resetTotp') }}
            </UiButton>
            <UiButton
              v-if="hasPermission('affiliates_can_login') && info.account_status !== 'blocked' && info.email_verified &&
                $store.getters['session/significantActionsSeconds'] === 0"
              icon="sign-in-alt"
              class="action-btn no-events"
              @click="checkSensitiveAction('')"
            >
              {{ $t('affiliates.cardView.toolbar.btns.login') }}
            </UiButton>
            <a
              v-if="hasPermission('affiliates_can_login') && info.account_status !== 'blocked' && info.email_verified &&
                $store.getters['session/significantActionsSeconds'] !== 0"
              :href="info.login_url"
              target="_blank"
              class="login-link"
            >
              <UiButton
                icon="sign-in-alt"
                class="action-btn "
              >{{ $t('affiliates.cardView.toolbar.btns.login') }}</UiButton>
            </a>
            <UiButton
              v-if="isEditStatus && hasPermission('affiliates_can_revoke')"
              icon="eye"
              class="action-btn"
              @click="revokeAffiliateHandler"
            >
              {{ $t('affiliates.cardView.toolbar.btns.revoke') }}
            </UiButton>
            <UiButton
              v-if="canOpenCreatePayment"
              icon="money-bill-wave-alt"
              class="action-btn"
              @click="createPayment"
            >
              {{ $t('affiliates.cardView.toolbar.btns.create_payment') }}
            </UiButton>
            <a
              v-if="isViewReports"
              :href="affiliateStatisticSupported ? reportParam : undefined"
              class="login-link"
              @click.prevent="() => {
                affiliateStatisticSupported ? $router.push(reportParam) : undefined
              }"
            >
              <UiButton
                icon="chart-bar"
                class="action-btn el-dropdown-link"
                :disabled="!affiliateStatisticSupported"
              >{{ $t('affiliates.cardView.toolbar.btns.statistics') }}</UiButton>
            </a>
            <UiButton
              v-if="canSkipKyc"
              icon="arrow-right-long-to-line"
              class="action-btn"
              @click="skipKycHandler"
            >
              {{ $t('affiliates.cardView.toolbar.btns.skip_kyc') }}
            </UiButton>
            <UiButton
              v-else-if="showAskForKycButton"
              icon="address-card"
              class="action-btn"
              :disabled="isKycActionDisabled"
              @click="askForKycHandler"
            >
              {{ $t('affiliates.cardView.toolbar.btns.ask_kyc') }}
            </UiButton>
            <UiButton
              v-if="info.account_status === 'blocked' && isEditStatus && hasPermission('affiliates_can_unblock')"
              icon="unlock"
              class="action-btn"
              @click="unblockAffiliateHandler"
            >
              {{ $t('affiliates.cardView.toolbar.btns.unblock') }}
            </UiButton>
            <UiButton
              icon="face-viewfinder"
              class="action-btn"
              :type="monitoringInfo ? 'negative' : 'positive'"
              @click="monitoringInfo ? handleStopMonitoredClick() : handleMonitoredClick()"
            >
              {{ monitoringInfo ? $t('affiliates.monitored.stop_monitoring') : $t('affiliates.monitored.start_monitoring') }}
            </UiButton>
            <UiButton
              v-if="info.account_status === 'approved' && isEditStatus && hasPermission('affiliates_can_block')"
              icon="lock"
              type="negative"
              class="action-btn"
              @click="blockAffiliateHandler"
            >
              {{ $t('affiliates.cardView.toolbar.btns.block') }}
            </UiButton>
            <UiButton
              v-if="canEditTrafficBlock"
              :icon="isTrafficBlocked ? 'lock-open' : 'arrow-down-up-lock'"
              :type="isTrafficBlocked ? 'positive' : 'negative'"
              class="action-btn"
              @click="openTrafficBlockPopup"
            >
              {{ isTrafficBlocked ? $t('affiliates.trafficBlock.button.unblock') : $t('affiliates.trafficBlock.button.block') }}
            </UiButton>
          </div>
        </div>
      </div>
      <div class="info">
        <div class="sidebar">
          <div class="card">
            <div class="title">
              <div class="title-content">
                <span>{{ $t('affiliates.affiliatesInfo.currency.label') }}</span>
                <span
                  v-if="isEditCurrencies"
                  style="color: #20815e"
                  class="action"
                  @click="checkSensitiveAction('handleEditCurrency')"
                >
                  <UiIcon
                    name="pen"
                    color="#20815e"
                  />
                  {{ $t(`affiliates.affiliatesInfo.edit`) }}
                </span>
              </div>
            </div>
            <div class="card-content">
              <div class="field">
                <span class="label">{{ activeCurrency.name }}</span>
              </div>
            </div>
          </div>
          <div class="card balance">
            <div class="title">
              <div class="title-content">
                <span>{{ $t(`affiliates.cardView.info.balance`) }}</span>
                <div class="buttons-wrapper">
                  <span
                    style="color: #20815e"
                    class="action"
                    @click="showBalanceHistory"
                  >
                    <UiIcon
                      name="history"
                      color="#20815e"
                    />
                    {{ $t(`affiliates.affiliatesInfo.history`) }}
                  </span>
                  <span
                    v-if="isEditBalance && hasPermission('affiliates_balance_edit')"
                    style="color: #20815e"
                    class="action"
                    @click="checkSensitiveAction('handleEditBls')"
                  >
                    <UiIcon
                      name="pen"
                      color="#20815e"
                    />
                    {{ $t(`affiliates.affiliatesInfo.edit`) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="card-content">
              <div class="field">
                <span class="label">{{ $t(`affiliates.affiliatesInfo.total`) }}</span>
                <div
                  :class="{ negative: wallets.hold_balance + wallets.available_balance < 0 }"
                  class="values total_balance"
                >
                  {{ currencyPrefix }}{{ $filters.formatMoney(wallets.hold_balance + wallets.available_balance) }}
                </div>
              </div>
              <div class="field">
                <span class="label">{{ $t(`affiliates.affiliatesInfo.in_hold`) }}</span>
                <div
                  :class="{ negative: wallets.hold_balance < 0 }"
                  class="values"
                >
                  {{ currencyPrefix }}{{ $filters.formatMoney(wallets.hold_balance) }}
                </div>
              </div>
              <div class="field">
                <span class="label">{{ $t(`affiliates.affiliatesInfo.available`) }}</span>
                <div
                  :class="{ negative: wallets.available_balance < 0 }"
                  class="values"
                >
                  {{ currencyPrefix }}{{ $filters.formatMoney(wallets.available_balance) }}
                </div>
              </div>
            </div>
          </div>
          <CardBlock
            class="t:mb-16"
            :title="$t(`affiliates.affiliatesInfo.paymentinfo`)"
            :list="paymentInfo"
          >
            <template v-slot:action>
              <UiAction
                v-if="isPaymentMethod && hasPermission('affiliates_payment_info_edit') && info.allowed_to_update_payment_method"
                :action-name="$t(`affiliates.affiliatesInfo.edit`)"
                @click="checkSensitiveAction('handleEditPayment')"
              />
            </template>
          </CardBlock>
          <div class="card card-max-limits">
            <div class="title">
              <div class="title-content">
                <span>{{ $t(`affiliates.affiliatesInfo.max_limits`) }}</span>
                <span
                  v-if="isEditLimits"
                  style="color: #20815e"
                  class="action"
                  @click="handleEditLimits"
                >
                  <UiIcon
                    name="pen"
                    color="#20815e"
                  />
                  {{ $t(`affiliates.affiliatesInfo.edit`) }}
                </span>
              </div>
            </div>
            <div class="card-content">
              <div class="field">
                <span class="label">{{ $t(`affiliates.affiliatesInfo.max_api_keys`) }}</span>
                <div class="values">
                  {{ info.limits && info.limits.max_api_keys ? parseFloat(info.limits.max_api_keys).toLocaleString('en-US') : $t(`affiliates.affiliatesInfo.max_default`) }}
                </div>
              </div>
              <div class="field">
                <span class="label">{{ $t(`affiliates.affiliatesInfo.max_promo_codes`) }}</span>
                <div class="values">
                  <template v-if="!info.limits?.max_promo_codes_levels?.length">
                    {{ $t(`affiliates.affiliatesInfo.max_default`) }}
                  </template>
                </div>
              </div>
              <div
                v-if="info.limits?.max_promo_codes_levels?.length"
                class="field max-promo-levels-row"
              >
                <div
                  v-for="(item, index) in info.limits.max_promo_codes_levels"
                  :key="index"
                  class="max-promo-level-row"
                >
                  <div class="t:flex t:items-center">
                    <i class="fa fa-greater-than-equal less-or-equal" />
                    <span class="t:ml-4">
                      {{ item.ftd_count }} FTD
                    </span>
                  </div>
                  <span>
                    {{ item.max_amount }}
                  </span>
                </div>
              </div>
              <div class="field">
                <span class="label">{{ $t(`affiliates.affiliatesInfo.max_traffic_sources`) }}</span>
                <div class="values">
                  {{ info.limits && info.limits.max_traffic_sources ? parseFloat(info.limits.max_traffic_sources).toLocaleString('en-US') : $t(`affiliates.affiliatesInfo.max_default`) }}
                </div>
              </div>
              <div class="field">
                <span class="label card__label-max">{{ $t(`affiliates.affiliatesInfo.max_postbacks_per_traffic_source`) }}</span>
                <div class="values">
                  {{ info.limits && info.limits.max_postbacks_per_traffic_source ? parseFloat(info.limits.max_postbacks_per_traffic_source).toLocaleString('en-US') : $t(`affiliates.affiliatesInfo.max_default`) }}
                </div>
              </div>
              <div class="field">
                <span class="label card__label-max">{{ $t(`affiliates.affiliatesInfo.max_tags_per_traffic_source`) }}</span>
                <div class="values">
                  {{ info.limits && info.limits.max_tags_per_traffic_source ? parseFloat(info.limits.max_tags_per_traffic_source).toLocaleString('en-US') : $t(`affiliates.affiliatesInfo.max_default`) }}
                </div>
              </div>
              <div class="field">
                <span class="label card__label-max">{{ $t(`settings.systemSettings.createPromoCodes`) }}</span>
                <div class="values">
                  <span v-if="info.limits && info.limits.allow_promo_code_create_or_edit === null">{{ $t('affiliates.affiliatesInfo.max_default') }}</span>
                  <span
                    v-else-if="info.limits"
                    :style="{ color: info.limits && info.limits.allow_promo_code_create_or_edit ? 'var(--text-primary)' : 'var(--text-negative)' }"
                  >
                    {{ info.limits.allow_promo_code_create_or_edit ? $t('permissions.allow') : $t('permissions.deny') }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="body">
          <div class="body-info personal-info">
            <div class="card">
              <div class="title">
                <div class="title-content">
                  <span>{{ $t(`affiliates.cardView.info.personal_info`) }}</span>
                  <span
                    v-if="isEditPermission"
                    class="action success"
                    @click="handleEditInfo"
                  >
                    <UiIcon
                      name="pen"
                      class="success"
                    />
                    {{ $t(`affiliates.affiliatesInfo.edit`) }}
                  </span>
                </div>
              </div>
              <div class="card-content">
                <div class="field field__login">
                  <span
                    v-if="info.first_name || info.last_name"
                    class="label name"
                  >{{ `${info.first_name} ${info.last_name}` }}</span>
                  <span
                    v-else
                    class="label name empty"
                  >{{ $t('affiliates.affiliatesInfo.not_specefied') }}</span>
                  <div class="login-card">
                    <span class="label">{{ $t(`affiliates.cardView.info.lastLogin`) }}: </span>
                    <span
                      v-if="info.last_active"
                    >
                      {{ $filters.formatDate3(info.last_active) }}
                    </span>
                    <span
                      v-else
                    >
                      {{ $t(`affiliates.cardView.info.lastLoginEmpty`) }}
                    </span>
                    <span class="divider">|</span>
                    <span class="label">{{ $t(`affiliates.cardView.info.regDae`) }}:</span> {{ $filters.formatDate3(info.created_at) }}
                    <template v-if="panelSettings?.kyc?.enabled">
                      <span class="divider">|</span>
                      <span class="label">KYC: </span>
                      <span
                        :style="{ color: kycStatusColor }"
                      >
                        {{ $t(`affiliates.cardView.info.kyc_${kycStatus}`) }}
                      </span>
                    </template>
                  </div>
                </div>
                <div class="field without-padding">
                  <div class="card">
                    <div class="field field-solo">
                      <UiIcon
                        :size="14"
                        color="var(--text-primary)"
                        name="phone"
                        class="ico"
                      />
                      <span
                        v-if="info.phone_number"
                        class="phone"
                      >
                        <a :href="`tel:${info.phone_number}`">{{ info.phone_number }}</a>
                      </span>
                      <span
                        v-else
                        class="phone empty"
                      >{{ $t('affiliates.affiliatesInfo.not_specefied') }}</span>
                    </div>
                    <div class="field">
                      <span class="mail-wrapper">
                        <UiIcon
                          :size="14"
                          color="var(--text-primary)"
                          name="envelope"
                          class="ico"
                        />
                        <span
                          v-if="info.email"
                          class="phone"
                        >
                          <a
                            :href="`mailto:${info.email}`"
                            rel="noopener noreferrer"
                            target="_blank"
                          >{{ info.email }}</a>
                          <UiIcon
                            :size="10"
                            :name="info.email_verified ? 'check' : ''"
                            :class="info.email_verified ? 'success' : ''"
                          />
                        </span>
                        <span
                          v-else
                          class="phone empty"
                        >{{ $t('affiliates.affiliatesInfo.not_specefied') }}</span>
                      </span>
                      <span
                        v-if="isEditPermission && hasPermission('affiliates_email_edit')"
                        class="action success"
                        @click="handleChangeMail"
                      >
                        <UiIcon
                          name="pen"
                          class="success"
                        />
                        {{ $t(`affiliates.affiliatesInfo.edit`) }}
                      </span>
                    </div>
                    <div class="field">
                      <span
                        v-show="info.messenger_id && info.messenger_id"
                        :class="info.messenger"
                        class="messenger"
                      >
                        <a
                          :href="getMessangerLink()"
                          rel="noopener noreferrer"
                          target="_blank"
                          class="t:truncate"
                        >{{ info.messenger_id }}</a>
                      </span>
                    </div>
                    <div class="field">
                      <span class="label">{{ $t(`affiliates.cardView.info.birthDay`) }}</span>
                      <div
                        v-if="info.date_of_birth"
                        class="values"
                      >
                        {{ $filters.formatDate4(info.date_of_birth) }}
                      </div>
                      <div
                        v-else
                        class="values empty"
                      >
                        {{ $t('affiliates.affiliatesInfo.not_specefied') }}
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <CardItem
                      :item="{name: $t(`affiliates.cardView.info.country`), value: getContryName}"
                      no-border
                    />
                    <CardItem
                      :item="{name: $t(`affiliates.cardView.info.city`), value: info.city}"
                    />
                    <CardItem
                      :item="{name: $t(`affiliates.cardView.info.postal_code`), value: info.postal_code}"
                    />
                    <CardItem
                      :item="{name: $t(`affiliates.cardView.info.address`), value: info.address}"
                    />
                  </div>
                </div>
                <div
                  v-if="!info.referred_by && isUpdateReferralProgram"
                  class="field field-info"
                >
                  <div class="field-info_title">
                    <span>{{ $t('affiliates.cardView.info.introducedEmpty') }}</span>
                  </div>
                  <div class="field-info_controls">
                    <span
                      :style="{color: 'var(--text-primary)'}"
                      class="action"
                      @click="checkSensitiveAction('introducedPin')"
                    >
                      <UiIcon
                        name="link"
                        color="var(--text-primary)"
                      />
                      {{ $t(`affiliates.affiliatesInfo.pin`) }}
                    </span>
                  </div>
                </div>
                <div
                  v-if="info.referred_by"
                  class="field field-info"
                >
                  <div class="field-info_title">
                    <span>{{ $t('affiliates.cardView.info.introduced') }}:</span> {{ info.referred_by_info.email }}
                  </div>
                  <div class="field-info_controls">
                    <span
                      v-if="info.referred_by_info.permissions.view"
                      class="action success"
                      @click="handleIntroducedCommand('open')"
                    >
                      <UiIcon
                        name="info-circle"
                        class="success"
                      />
                      {{ $t(`affiliates.affiliatesInfo.openInfo`) }}
                    </span>
                    <span
                      v-if="isEditPermission && isUpdateReferralProgram"
                      class="action decline"
                      @click="checkSensitiveAction('introducedUnpin')"
                    >
                      <UiIcon
                        name="unlink"
                        class="decline"
                      />
                      {{ $t(`affiliates.affiliatesInfo.unpin`) }}
                    </span>
                  </div>
                </div>
                <div
                  v-if="info.team_name"
                  class="field field-info"
                >
                  <div class="field-info_title">
                    <span>{{ $t('affiliates.cardView.info.team') }}:</span> {{ info.team_name }}
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="title">
                <div class="title-content">
                  <span>{{ $t('affiliates.affiliatesInfo.report_setting') }}</span>
                  <span
                    v-if="!editReporting && isReportingSettings && isEditPermission && (hasPermission('affiliates_reporting_settings_cpa_profit_visibility_edit') || hasPermission('affiliates_reporting_settings_rs_profit_visibility_edit'))"
                    style="color: #20815e"
                    class="action"
                    @click="editReportingSettings"
                  >
                    <UiIcon
                      name="pen"
                      color="#20815e"
                    />
                    {{ $t(`affiliates.affiliatesInfo.edit`) }}
                  </span>
                  <div
                    v-else-if="editReporting && isReportingSettings"
                    class="values"
                  >
                    <span
                      :style="{color: 'var(--text-negative)'}"
                      class="action"
                      @click="cancelEdit('reportSettings')"
                    >
                      <UiIcon
                        name="times"
                        color="var(--text-negative)"
                      />
                      {{ $t(`affiliates.affiliatesInfo.cancel`) }}
                    </span>
                    <span
                      style="color: #20815e"
                      class="action"
                      @click="saveEdit('reportSettings')"
                    >
                      <UiIcon
                        name="check"
                        color="#20815e"
                      />
                      {{ $t(`affiliates.affiliatesInfo.save`) }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="card-content">
                <div class="t:grid t:grid-cols-2">
                  <UiCheckbox
                    v-model="reports.cpa_profit_viewable"
                    :label="$t(`affiliates.affiliatesInfo.cpa_profit`)"
                    :disabled="!isEditPermission || !hasPermission('affiliates_reporting_settings_cpa_profit_visibility_edit') || !editReporting"
                    class="t:py-8"
                  />
                  <UiCheckbox
                    v-model="reports.revshare_profit_viewable"
                    :disabled="!isEditPermission || !hasPermission('affiliates_reporting_settings_rs_profit_visibility_edit') || !editReporting"
                    :label="$t(`affiliates.affiliatesInfo.refshare_profit`)"
                    class="t:py-8"
                  />
                  <UiCheckbox
                    v-model="reports.referred_cpa_profit_viewable"
                    :label="$t(`affiliates.affiliatesInfo.cpa_profit_for_aff`)"
                    :disabled="!isEditPermission || !hasPermission('affiliates_reporting_settings_cpa_profit_visibility_edit') || !editReporting"
                    class="t:py-8"
                  />
                  <UiCheckbox
                    v-model="reports.referred_revshare_profit_viewable"
                    :disabled="!isEditPermission || !hasPermission('affiliates_reporting_settings_rs_profit_visibility_edit') || !editReporting"
                    :label="$t(`affiliates.affiliatesInfo.refshare_profit_for_aff`)"
                    class="t:py-8"
                  />
                </div>
              </div>
            </div>
            <!-- media_buying -->
            <MediaBuyingSettingCard
              :id="id"
              :info="info"
              :is-edit-permission="isEditPermission"
              :has-permission="hasPermission('affiliates_media_buying_edit')"
              :edit-buying="editBuying"
              :customer-currency="wallets.currency_code"
              :media-buying="mediaBuying"
              :get-contry-name="getContryName"
              @cancel-edit="cancelEdit"
              @save-edit="fetchAffiliateData"
            />

            <div class="card">
              <div class="title">
                <div class="title-content">
                  <span>{{ $t('affiliates.affiliatesInfo.notifications_setting') }}</span>
                  <span
                    v-if="isEditPermission && hasPermission('affiliates_domain_change_notifications_edit')"
                    style="color: #20815e"
                    class="action"
                    @click="handleEditNotificationsStatus"
                  >
                    <UiIcon
                      name="pen"
                      color="#20815e"
                    />
                    {{ $t(`affiliates.affiliatesInfo.edit`) }}
                  </span>
                </div>
              </div>
              <div class="card-content">
                <div class="field without-padding">
                  <div class="card">
                    <div class="field field-solo">
                      <div class="column">
                        <div
                          v-if="info.service_domain_changes_notifications_enabled"
                          class="column-text"
                        >
                          <UiIcon
                            v-if="info.service_domain_changes_notifications_channel === 'email'"
                            :size="14"
                            color="var(--text-primary)"
                            name="envelope"
                            class="ico"
                          />
                          <span
                            v-else
                            class="messenger telegram"
                          />
                          {{ $t(`affiliates.affiliate_notifications.type.${info.service_domain_changes_notifications_channel}`) }}
                        </div>
                        <div
                          v-else
                          class="column-text red-text"
                        >
                          {{ $t(`affiliates.affiliate_notifications.disabled`) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <RotationGroupsCard
              :id="id"
              ref="rotationGroupsCard"
              :edit-permission="isEditPermission && hasPermission('affiliates_rotation_groups_edit') && hasPermission('service_rotation_groups_view' )"
            />

            <div class="card">
              <div class="title">
                <span>{{ $t(`affiliates.affiliatesInfo.multiaccounts`) }}</span>
              </div>
              <div class="card-content">
                <div v-if="multiaccounts.length > 0">
                  <div
                    v-for="item in multiaccounts"
                    :key="item.id"
                    class="field t:flex t:justify-between t:items-center"
                  >
                    <RouterLink
                      class="site"
                      :to="`/affiliates/${item.id}/info`"
                    >
                      {{ item.email }}
                    </RouterLink>
                    <div
                      v-if="item.account_status && statuses[item.account_status]"
                      class="t:ml-4 t:flex t:items-center"
                    >
                      <UiIcon
                        :name="statuses[item.account_status].icon"
                        :color="statuses[item.account_status].color"
                      />
                      <span
                        class="values"
                        :style="{ color: statuses[item.account_status].color }"
                      >{{ $t(`affiliates.listView.toolbar[1].statusFilter.${item.account_status}`) }}</span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="multiaccounts.length === 0"
                  class="field"
                >
                  <span class="empty">{{ $t('affiliates.affiliatesInfo.not_specefied') }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="right-side">
            <MonitoringInfo
              v-if="monitoringInfo"
              class="t:mb-16"
              :info="monitoringInfo"
              @stop="handleStopMonitoredClick"
              @edit="handleMonitoredClick"
            />
            <div
              v-if="info.is_public_profile_enabled"
              class="card"
            >
              <div class="title">
                <div class="title-content">
                  <span>{{ $t(`affiliates.public_profile.title`) }}</span>
                  <div
                    v-if="isEditPermission"
                    class="t:flex"
                  >
                    <span
                      v-if="info.public_profile"
                      class="action delete"
                      @click="handleDeletePublicProfile"
                    >
                      <UiIcon
                        name="trash-alt"
                      />
                      {{ $t('crm.buttons.delete') }}
                    </span>
                    <span
                      style="color: #20815e"
                      class="action t:ml-16"
                      @click="$refs.editPublicProfile.open(info.public_profile)"
                    >
                      <UiIcon
                        name="pen"
                        color="#20815e"
                      />
                      {{ $t('affiliates.affiliatesInfo.edit') }}
                    </span>
                  </div>
                </div>
              </div>
              <div
                v-if="info.public_profile"
                class="card-content"
              >
                <div class="field">
                  <ElTooltip
                    placement="left"
                    :content="info.public_profile.name"
                  >
                    <span class="label name">{{ info.public_profile.name }}</span>
                  </ElTooltip>
                </div>
                <div
                  v-for="(contact, i) in info.public_profile.contacts"
                  :key="i"
                  class="field"
                >
                  <ElTooltip
                    placement="left"
                    class="t:w-full"
                    :content="contact.value"
                  >
                    <div class="t:flex t:overflow-hidden">
                      <UiIcon
                        v-if="contact.type === 'email'"
                        :size="14"
                        color="var(--text-primary)"
                        name="envelope"
                        class="ico t:shrink-0"
                      />
                      <span
                        v-else
                        class="messenger t:shrink-0"
                        :class="contact.type"
                      />
                      <a
                        :href="getMessangerLink(contact.type, contact.value)"
                        class="social-link value"
                        :target="contact.type === 'email' && '_blank'"
                      >
                        {{ contact.value }}
                      </a>
                    </div>
                  </ElTooltip>
                </div>
                <div
                  v-if="info.public_profile.additional_information"
                  class="field misc"
                  v-html="info.public_profile.additional_information"
                />
              </div>
              <div
                v-else
                class="no-public-profile"
              >
                <i class="fas fa-user t:mr-8" />
                {{ $t('affiliates.public_profile.no_data') }}
              </div>
            </div>
            <div
              v-if="hasPermission('affiliates_activity_log_view')"
              class="card"
            >
              <div class="title">
                <div class="title-content">
                  <span>{{ $t(`affiliates.cardView.info.historyTitle`) }}</span>
                  <span
                    style="color: #20815e"
                    class="action"
                  >
                    <UiIcon
                      name="history"
                      color="#20815e"
                    />
                    <RouterLink
                      :to="`/affiliates/${id}/activity`"
                    >{{ $t(`affiliates.cardView.info.historyLink`) }}</RouterLink>
                  </span>
                </div>
              </div>
              <div class="card-content">
                <div />
                <div v-if="activity.length > 0">
                  <div
                    v-for="(item, index) in activity"
                    :key="index"
                    class="point field"
                  >
                    <span class="time">{{ $filters.formatDate3(item.action_timestamp) }}</span>
                    <span class="value">{{ item.action_name }}</span>
                  </div>
                </div>

                <div
                  v-if="activity.length === 0"
                  class="field"
                >
                  <div class="field__empty-text">
                    <UiIcon
                      :size="32"
                      name="folder-open"
                      substyle="fal"
                      color="#a6b2c4"
                    />
                    <div>{{ $t(`affiliates.cardView.info.noHistoryTitle`) }}</div>
                  </div>
                </div>
              </div>
            </div>
            <Notes
              v-if="hasPermission('affiliates_notes_view')"
              ref="notesRef"
              :add-note-permission="isEditPermission && hasPermission('affiliates_notes_edit')"
              :affiliate-id="$route.params.id"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { format, subYears } from 'date-fns';
import { NAV_SET_SUB_VIEW } from '@/store/action_types/nav';

import ResetPasswordPopup from '@/components/Popups/ResetPasswordPopup.vue';
import MonitoringPopup from '@/components/Popups/MonitoringPopup.vue';
import Notes from '@/components/Notes.vue';
import AffiliateSubPopupTemporary from '@/components/Popups/AffiliateSubPopupTemporary.vue';
import errorHandleMixin from '@/views/mixins/error-hadle';
import EditPublicProfile from '@/views/Affiliates/Affiliate/components/EditPublicProfile.vue';
import { locales } from '@/helpers/date-locales';
import MonitoringInfo from '@/views/Affiliates/Affiliate/components/MonitoringInfo.vue';
import MediaBuyingSettingCard from './components/MediaBuyingSettingCard.vue';
import RotationGroupsCard from './components/RotationGroupsCard.vue';

const formatCurrencies = ({ code, name, ...restParams }) => ({
  code,
  name: `${code} - ${name}`,
  ...restParams,
});

export default {
  name: 'AffiliateInfo',
  components: {
    EditPublicProfile,
    Notes,
    ResetPasswordPopup,
    MonitoringPopup,
    AffiliateSubPopupTemporary,
    RotationGroupsCard,
    MediaBuyingSettingCard,
    MonitoringInfo,
  },
  mixins: [errorHandleMixin],
  props: {
    info: {
      type: Object,
      default: () => ({
        site_url: [],
      }),
    },
    permissions: {
      type: Object,
      default: () => ({}),
    },
    multiaccounts: {
      type: Array,
      default: () => ([]),
    },
    isParentDataLoading: {
      type: Boolean,
      default: false,
    },

  },
  emits: ['update:info'],
  data() {
    return {
      isLoading: false,
      confirmData: {},
      targetAffiliate: {},
      errorWallet: [],
      editReporting: false,
      editBuying: false,
      isEditPayment: false,
      id: '',
      availableCurrencies: [],
      currentCurrency: null,
      newEmail: '',
      infoDump: {},
      wallets: {},
      errors: {},
      // isConfirmOpen: false,
      confirmMsg: '',
      confirmAction: '',
      confirmTitle: '',
      confirmType: '',
      actionName: '',
      actionFaIcon: '',
      actionIcon: '',
      confirmDangerButton: true,
      isResetOpen: false,
      isPinOpen: false,
      isMonitoringPopupOpen: false,
      monitoringInfo: null,
      popupInfo: {},
      notification: {
        service_domain_changes_notifications_enabled: false,
        service_domain_changes_notifications_channel: '',
      },
      payment: {
        site_payment_method_id: null,
        payment_wallet: null,
        payments_net: '',
        vat: '',
        payments_negative_carryover: '',
        payments_enabled: false,
        reason: '',
      },

      commissions: {
        deposits_cpa_commission: '',
        withdrawals_cpa_commission: '',
        deposits_rs_commission: '',
        withdrawals_rs_commission: '',
      },
      limits: {
        max_api_keys: '',
        max_postbacks_per_traffic_source: '',
        max_promo_codes_levels: [],
        max_tags_per_traffic_source: '',
        max_traffic_sources: '',
        allow_promo_code_create_or_edit: 'default',
      },
      balance: {
        operation: 'deposit',
        sum: '',
        note: '',
        reflect_in_statistics: true,
      },
      activity: [],
      isDataLoading: true,
      reports: {
        cpa_profit_viewable: false,
        referred_cpa_profit_viewable: false,
        revshare_profit_viewable: false,
        referred_revshare_profit_viewable: false,
      },
      mediaBuying: {
        media_buying_enabled: false,
        media_buying_auto_approve_posts_cost_per_player: null,
        media_buying_auto_approve_posts_max_amount: null,
        media_buying_balance_limit: null,
        media_buying_pending_balance: null,
        media_buying_limits_currency_code: null,
        media_buying_pending_balance_currency_code: null,
      },
      // isOpenRotationGroupsPopup: false,
      // rotationGroups: [],
      editBls: {
        type: 'success',
        title: '',
        msg: '',
        action: '',
      },
      confirmChangeMail: {
        title: '',
      },
      confirmEditLimits: {
        type: 'success',
        title: '',
        action: '',
        actionFaIcon: 'check',
      },
      confirmEditPayment: {
        type: 'success',
        title: '',
        msg: '',
        action: '',
        actionFaIcon: 'check',
      },
      editAffiliateOpen: false,
      confirmEditInfo: {
        type: 'success',
        title: '',
        action: '',
      },
      editSiteUrl: {
        type: 'success',
        title: '',
        msg: '',
        action: '',
      },
      sitesList: [],
      infoCreatePayment: {},
      popoverDisabled: true,
      paymentMethodsByCurrencyCode: [],
      statuses: {
        blocked: {
          icon: 'lock',
          color: 'var(--text-negative)',
        },
        rejected: {
          icon: 'times-circle',
          color: 'var(--text-negative)',
        },
        approved: {
          icon: 'check',
          color: 'var(--text-primary)',
        },
        pending: {
          icon: 'eye',
          color: '#E1962B',
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      countries: 'misc/countries',
      currencies: 'misc/currencies',
      groups: 'misc/groups',
      paymentMethods: 'misc/paymentMethods',
      paymentPeriods: 'misc/paymentPeriods',
      messengersInfo: 'misc/apiMessengers',
      currentAcl: 'auth/currentAcl',
      adminAcl: 'auth/adminAcl',
      reportsSettings: 'reports/reportsSettings',
      panelSettings: 'reports/panelSettings',
    }),

    kycStatus() {
      return this.info?.kyc_status || 'unknown';
    },

    isKycActionDisabled() {
      return ['verified', 'requested'].includes(this.kycStatus);
    },
    canRequestKyc() {
      return this.hasPermission('affiliates_kyc_request') && this.permissions?.can_request_kyc;
    },
    canSkipKyc() {
      return this.kycStatus === 'requested' && this.hasPermission('affiliates_kyc_skip');
    },
    showAskForKycButton() {
      return this.canRequestKyc && !this.canSkipKyc;
    },
    kycVerifiedTooltip() {
      return this.$t('affiliates.cardView.info.kyc_verified_tooltip');
    },

    kycStatusColor() {
      if (this.kycStatus === 'verified') {
        return 'var(--text-primary)';
      }
      if (this.kycStatus === 'requested') {
        return 'var(--text-warning)';
      }
      return 'var(--text-negative)';
    },

    pPaymentPeriods() {
      return this.paymentPeriods.map((el) => ({ id: el, name: this.$filters.uppercase(el) }));
    },

    balanceOperations() {
      return [
        {
          value: 'deposit',
          name: this.$t('affiliates.affiliatesInfo.deposit'),
        },
        {
          value: 'withdraw',
          name: this.$t('affiliates.affiliatesInfo.withdraw'),
        },
      ];
    },
    paymentInfo() {
      return [
        {
          name: this.$t('affiliates.cardView.info.payments_enabled'),
          value: this.info.payments_enabled ? this.$t('affiliates.cardView.info.status_yes') : this.$t('affiliates.cardView.info.status_no'),
        },
        {
          name: this.$t('affiliates.affiliatesInfo.method'),
          value: this.humanizePaymentMethod(this.info.site_payment_method_id) ? this.humanizePaymentMethod(this.info.site_payment_method_id) : '',
        },
        {
          name: this.$t('affiliates.affiliatesInfo.wallet'),
          value: this.info.payment_wallet,
        },
        {
          name: this.$t('affiliates.affiliatesInfo.period'),
          value: this.$filters.capitalize(this.info.payments_net),
        },
        {
          name: this.$t('affiliates.cardView.info.negative_carryover'),
          value: this.info.payments_negative_carryover ? this.$t('affiliates.cardView.info.status_yes') : this.$t('affiliates.cardView.info.status_no'),
        },
      ];
    },

    disabledDate() {
      return subYears(new Date(), 18);
    },
    promoCodesOption() {
      return [
        {
          id: 'default',
          name: this.$t('affiliates.affiliatesInfo.max_default'),
        },
        {
          id: 'false',
          name: this.$t('permissions.deny'),
        },
        {
          id: 'true',
          name: this.$t('permissions.allow'),
        },
      ];
    },
    currencyOptions() {
      if (!this.$_.isEmpty(this.activeCurrency)) {
        return this.$_.uniqBy([this.activeCurrency, ...this.availableCurrencies], 'code');
      }

      return this.availableCurrencies;
    },
    activeCurrency() {
      return this.currencies.find((currency) => currency.code === this.wallets.currency_code) || {};
    },
    currencyPrefix() {
      return this.activeCurrency.symbol || `${this.wallets.currency_code || ''} `;
    },
    notificationsType() {
      return [
        {
          id: 'telegram',
          name: 'Telegram',
          is_disabled: !this.panelSettings.telegram_bot.bot_username,
        },
        {
          id: 'email',
          name: 'E-mail',
        },
      ];
    },

    affiliateStatisticSupported() {
      return !!this.reportsSettings.dimensions
        .map((dim) => dim.column_name)
        .find((grouping) => grouping === 'affiliate_email');
    },

    noteData: {
      get() {
        return this.confirmData ? this.confirmData : {};
      },
    },
    isEditLimits() {
      return this.calcPermissions('edit_limits');
    },
    isViewReports() {
      return this.calcPermissions('view_reports');
    },
    affiliateStats() {
      return {
        id: this.info.id,
        email: this.info.email,
        incrementing_id: this.info.incrementing_id,
      };
    },
    reportParam() {
      return `/reports/custom?affiliate_stats=${encodeURIComponent(this.$qs.stringify(this.affiliateStats))}`;
    },
    isEditBalance() {
      return this.calcPermissions('edit_balance');
    },
    isEditAffiliate() {
      return this.calcPermissions('edit');
    },
    isEditCurrencies() {
      return this.info.account_status === 'approved' && this.isEditAffiliate && this.isEditBalance && this.hasPermission('affiliates_edit');
    },
    canCreateInternalPayment() {
      return this.calcPermissions('create_payments')
        && this.info.payments_enabled
        && this.info.account_status === 'approved'
        && this.hasPermission('affiliates_payments_can_create');
    },
    canCreateExternalPayment() {
      return this.info.account_status === 'approved' && this.hasPermission('payments_external_payouts_actions');
    },
    canOpenCreatePayment() {
      return this.canCreateInternalPayment || this.canCreateExternalPayment;
    },
    isEditStatus() {
      return this.calcPermissions('account_status_actions');
    },
    isResetTotp() {
      return this.calcPermissions('reset_totp');
    },
    isPaymentMethod() {
      return this.calcPermissions('update_payment_method');
    },
    isReportingSettings() {
      return this.calcPermissions('update_reporting_settings');
    },
    isEditPass() {
      return this.calcPermissions('update_password');
    },
    isEditPermission() {
      return this.calcPermissions('edit') && this.hasPermission('affiliates_edit');
    },
    isUpdateReferralProgram() {
      return this.calcPermissions('update_referral_program');
    },

    placeholderWallet() {
      if (this.paymentMethods.length !== 0 && this.payment.site_payment_method_id) {
        return this.$_.find(this.paymentMethods, (e) => e.id === this.payment.site_payment_method_id)?.wallet_placeholder || '';
      }
      return '';
    },
    placeholderMessenger() {
      if (this.messengersInfo.length !== 0 && this.popupInfo.messenger) {
        return this.$_.find(this.messengersInfo, (e) => e.id === this.popupInfo.messenger)?.example_placeholder || '';
      }
      return '';
    },
    isDataLoadingComputed() {
      return this.isDataLoading || this.isParentDataLoading;
    },
    isTrafficBlocked() {
      return this.info?.is_traffic_blocked;
    },
    canEditTrafficBlock() {
      return this.isEditStatus
        && this.hasPermission('affiliates_traffic_block_edit')
        && this.calcPermissions('edit_traffic_block');
    },
    getContryName() {
      const c = this.countries.find((country) => country.code === this.info.country_code);
      if (c) {
        return c.name;
      }
      return '';
    },
    isInfoEmpty() {
      return this.$_.isEmpty(this.info);
    },

    isShowButtons() {
      if (this.info.account_status === 'pending') {
        return (this.isEditStatus && this.hasPermission('affiliates_can_decline'))
          || (this.info.email_verified && this.isEditStatus)
          || this.canOpenCreatePayment
          || (this.isEditStatus && this.hasPermission('affiliates_can_approve'));
      }
      if (this.info.account_status === 'rejected') {
        return (!this.info.email_verified && this.isEditStatus)
          || this.canOpenCreatePayment
          || (this.isEditStatus && this.hasPermission('affiliates_can_revoke'));
      }
      return (this.info.account_status === 'approved' && this.isEditStatus && this.hasPermission('affiliates_can_block'))
        || (this.info.account_status === 'blocked' && this.isEditStatus && this.hasPermission('affiliates_can_unblock'))
        || this.canEditTrafficBlock
        || this.canOpenCreatePayment
        || (this.isEditStatus && this.hasPermission('affiliates_can_revoke'))
        || (this.hasPermission('affiliates_can_login'))
        || this.isViewReports
        || (this.info.google2fa_enabled && this.isResetTotp)
        || (this.isEditPass && this.hasPermission('affiliates_password_edit'))
        || (!this.info.email_verified && this.isEditStatus);
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.id = to.params.id;
    if (!this.id) {
      this.$router.push('/affiliates/list');
      return;
    }
    this.fetchAffiliateData();

    next();
  },
  watch: {
    info: {
      handler(value) {
        this.isDataLoading = true;
        this.popupInfo = this.$_.cloneDeep(value);
        [
          this.payment.payments_enabled,
          this.payment.site_payment_method_id,
          this.payment.payment_wallet,
          this.payment.payments_net,
          this.payment.vat,
          this.payment.payments_negative_carryover,

          this.mediaBuying.media_buying_auto_approve_posts_cost_per_player,
          this.mediaBuying.media_buying_auto_approve_posts_max_amount,
          this.mediaBuying.media_buying_balance_limit,
          this.mediaBuying.media_buying_enabled,
          this.mediaBuying.media_buying_pending_balance,
          this.mediaBuying.media_buying_limits_currency_code,
          this.mediaBuying.media_buying_pending_balance_currency_code,

          this.reports.cpa_profit_viewable,
          this.reports.referred_cpa_profit_viewable,
          this.reports.revshare_profit_viewable,
          this.reports.referred_revshare_profit_viewable,
          this.notification.service_domain_changes_notifications_enabled,
          this.notification.service_domain_changes_notifications_channel,
        ] = [
          value.payments_enabled,
          value.site_payment_method_id,
          value.payment_wallet,
          value.payments_net,
          value.vat,
          value.payments_negative_carryover,

          value.media_buying_auto_approve_posts_cost_per_player,
          value.media_buying_auto_approve_posts_max_amount,
          value.media_buying_balance_limit,
          value.media_buying_enabled,
          value.media_buying_pending_balance,
          value.media_buying_limits_currency_code,
          value.media_buying_pending_balance_currency_code,

          value.cpa_profit_viewable,
          value.referred_cpa_profit_viewable,
          value.revshare_profit_viewable,
          value.referred_revshare_profit_viewable,
          value.service_domain_changes_notifications_enabled,
          value.service_domain_changes_notifications_channel,
        ];
        if (value.limits) {
          this.limits = this.$_.cloneDeep(value.limits);
          if (this.limits.allow_promo_code_create_or_edit === null) {
            this.limits.allow_promo_code_create_or_edit = 'default';
          } else {
            this.limits.allow_promo_code_create_or_edit = value.limits.allow_promo_code_create_or_edit === true ? 'true' : 'false';
          }
        }
        if (value.id) {
          this.fetchWallets(value.id)
            .finally(() => {
              this.isDataLoading = false;
            });

          this.$nextTick(() => {
            this.$refs.rotationGroupsCard.getRotationGroupsForAffiliate(value.id);
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },

  mounted() {
    this.id = this.$route.params.id;
    if (!this.id) {
      this.$router.push('/affiliates/list');
      return;
    }
    this.getAffiliateMonitoringInfo();

    if (this.hasPermission('affiliates_activity_log_view')) {
      this.getAffiliateActivity();
    }
  },

  created() {
    this.$eventBus.$on('handleEditBls', this.handleEditBls);
    this.$eventBus.$on('handleEditCurrency', this.handleEditCurrency);
    this.$eventBus.$on('handleEditPayment', this.handleEditPayment);
    this.$eventBus.$on('introducedPin', this.introducedPin);
    this.$eventBus.$on('introducedUnpin', this.introducedUnpin);
  },

  beforeUnmount() {
    if (!this.isStatic) {
      window.removeEventListener('resize', this.debouncedTableHeight);
    }
    this.$eventBus.$off('handleEditBls', this.handleEditBls);
    this.$eventBus.$off('handleEditCurrency', this.handleEditCurrency);
    this.$eventBus.$off('handleEditPayment', this.handleEditPayment);
    this.$eventBus.$off('introducedPin', this.introducedPin);
    this.$eventBus.$off('introducedUnpin', this.introducedUnpin);
  },
  methods: {
    isKycFieldLocked(field) {
      return (this.info?.kyc_locked_fields || []).includes(field);
    },
    getMessangerLink(messenger = this.info.messenger, messengerId = this.info.messenger_id) {
      switch (messenger) {
      case 'email':
        return `mailto:${messengerId}`;
      case 'telegram':
        return `tg://resolve?domain=${messengerId}`;
      case 'skype':
        return `skype:${messengerId}?chat`;
      case 'viber':
        return `viber://chat?number=${messengerId}`;
      case 'whatsapp':
        return `https://api.whatsapp.com/send?phone=${messengerId.replace(/[^\d]/g, '')}`;
      case 'facebook':
        return `https://www.facebook.com/${messengerId}`;
      case 'instagram':
        return `https://www.instagram.com/${messengerId}`;
      case 'twitter':
        return `https://twitter.com/@${messengerId}`;
      case 'ms_teams':
        return messengerId;
      default:
        return '#';
      }
    },
    deletePublicProfile() {
      this.isLoading = true;
      return this.$api.deleteAffiliatePublicProfile(this.$route.params.id)
        .then(() => this.fetchAffiliateData({ isSilent: true }))
        .finally(() => this.isLoading = false);
    },
    fetchAvailableCurrencies() {
      return this.$api.getAffiliateWalletsAvailableToSwitch(this.$route.params.id).then((res) => {
        this.availableCurrencies = res.data.payload.map(formatCurrencies);
      });
    },
    async fetchWallets(id = this.id) {
      const response = await this.$api.getAffiliateWallets(id);

      this.wallets = response.data.payload.find((wallet) => wallet.status === 'active');

      this.$api.getPaymentMethods({ currency_code: this.wallets.currency_code }).then((res) => {
        this.paymentMethodsByCurrencyCode = res.data.payload.sort((x, y) => {
          if (x.id === this.payment.site_payment_method_id) {
            return -1;
          }
          return x.is_disabled - y.is_disabled;
        });
      });
      return response;
    },
    handleEditCurrency() {
      this.fetchAvailableCurrencies();

      this.currentCurrency = this.wallets.currency_code;
      this.$refs.editCurrency.open();
    },
    checkSensitiveAction(action) {
      this.$eventBus.$emit('checkSensitiveAction', action);
    },

    hasPermission(permission) {
      return this.currentAcl[permission] === 'allow' || this.adminAcl.is_superuser;
    },

    calcPermissions(item) {
      return this.permissions[item];
    },

    isPopoverDisabled() {
      setTimeout(() => {
        const { wlt } = this.$refs;
        if (wlt !== undefined) {
          if (wlt.clientWidth < wlt.scrollWidth) {
            const style = wlt.currentStyle || window.getComputedStyle(wlt);
            this.popoverDisabled = style.textOverflow !== 'ellipsis';
            return;
          }
        }

        this.popoverDisabled = true;
      });
    },
    changeBalance() {
      const q = {
        operation_type: this.balance.operation,
        operation_description: this.balance.note,
        amount: +this.balance.sum,
        reflect_in_statistics: this.balance.reflect_in_statistics,
      };
      this.$api.changeBalance(this.wallets.id, q)
        .then(() => {
          this.$refs.editBls.close();
        })
        .catch((error) => {
          this.errors = error.data.errors;
        });
    },
    handleStopMonitoredClick() {
      this.confirmMsg = `${this.$t('affiliates.monitored.stopPopup.text', { affiliateEmail: this.info.email })}`;
      this.actionName = `${this.$t('affiliates.monitored.actionStop')}`;
      this.confirmTitle = `${this.$t('affiliates.monitored.stopPopup.title')}`;
      this.confirmType = 'warning';
      this.confirmAction = 'stopMonitoring';
      this.actionFaIcon = 'stop';
      this.$refs.confirm.open();
    },
    handleMonitoredClick() {
      this.isMonitoringPopupOpen = true;
    },
    handleEditBls() {
      this.editBls.title = this.$t('affiliates.confirm.title_1');
      this.editBls.msg = `${this.$t('affiliates.confirm.msg_1', { affiliateEmail: this.info.email })}`;
      this.editBls.actionFaIcon = 'check';
      this.$refs.editBls.open();
    },
    handleDeletePublicProfile() {
      this.confirmTitle = this.$t('affiliates.public_profile.confirm.title');
      this.confirmMsg = this.$t('affiliates.public_profile.confirm.msg');
      this.confirmType = 'warning';
      this.actionIcon = 'check';
      this.confirmAction = 'deletePublicProfile';
      this.actionName = this.$t('crm.buttons.delete');
      this.$refs.confirm.open();
    },
    handleEditNotificationsStatus() {
      this.editBls.title = this.$t('affiliates.confirm.title_1');
      this.editBls.msg = `${this.$t('affiliates.confirm.msg_1', { affiliateEmail: this.info.email })}`;
      this.$refs.changeNotificationsStatus.open();
    },
    saveBls() {
      this.confirmAction = 'editBls';
      this.confirmMsg = `${this.$t('affiliates.confirm.msg_2', { affiliateEmail: this.info.email })}`;
      this.actionName = this.$t('affiliates.confirm.action_2');
      this.confirmTitle = this.$t('affiliates.confirm.title_2');
      this.confirmType = 'success';
      this.actionFaIcon = 'check';
      this.$refs.confirm.open();
    },

    confirmPin({ affiliate, cb }) {
      this.targetAffiliate = this.$_.clone(affiliate);
      this.confirmTitle = `${this.$t('affiliates.affiliateSub.confirm.title_4', { subAffiliateEmail: this.info.email, affiliateEmail: affiliate.email })}`;
      this.confirmMsg = `${this.$t('affiliates.affiliateSub.confirm.msg_4', { subAffiliateEmail: this.info.email, affiliateEmail: affiliate.email })}`;
      this.confirmType = 'success';
      this.actionIcon = 'link';
      this.confirmAction = 'Pin';
      this.cbAction = cb;
      this.actionName = `${this.$t('affiliates.affiliateSub.confirm.action_4')}`;
      this.$refs.confirm.open();
    },
    cancelBls() {
      this.balance = {
        operation: 'deposit',
        sum: '',
        note: '',
        reflect_in_statistics: true,
      };
      this.errors = {};
      this.fetchAffiliateData();
    },
    addSite() {
      this.popupInfo.site_url.push('');
    },
    removeSite(i) {
      this.popupInfo.site_url.splice(i, 1);
    },
    handleEditLimits() {
      this.confirmEditLimits.title = this.$t('affiliates.confirm.limits_popup_title');
      this.$refs.confirmEditLimits.open();
      this.errors = {};
    },
    handleEditPayment() {
      this.confirmEditPayment.title = this.$t('affiliates.confirm.title_3');
      this.confirmEditPayment.msg = `${this.$t('affiliates.confirm.msg_3', { affiliateEmail: this.info.email })}`;
      this.$refs.confirmEditPayment.open();
      this.errors = {};
    },
    handleEditInfo() {
      this.confirmEditInfo.title = `${this.$t('affiliates.confirm.edit')} <span>${this.info.email}</span>`;
      this.$refs.confirmEditInfo.open();
      this.actionFaIcon = 'check';
      this.errors = {};
    },
    handleChangeMail() {
      this.newEmail = '';
      this.$refs.confirmChangeMail.open();
      this.confirmChangeMail.title = `${this.$t('affiliates.confirm.change_email_title', { name: `${this.info.first_name} ${this.info.last_name}` })}`;
      this.errors = {};
    },

    changeEmail() {
      this.errors = {};
      this.$api.postChangeEmail(this.id, this.newEmail).then(() => {
        this.$eventBus.$emit('update-email', this.newEmail);
        this.$refs.confirmChangeMail.close();
      })
        .catch((error) => {
          this.errors = error.data.errors;
        });
    },
    fetchAffiliateData({ isSilent = false } = {}) {
      if (!isSilent) {
        this.isDataLoading = true;
      }

      this.$api
        .getAffiliateInfo(this.id)
        .then((response) => {
          this.$emit('update:info', this.$_.cloneDeepWith(response.data.payload));
        })
        .finally(() => {
          this.isDataLoading = false;
          this.isPopoverDisabled();
        });
    },
    openTrafficBlockPopup() {
      if (!this.canEditTrafficBlock) {
        return;
      }
      this.$eventBus.$emit('open-popup', 'TrafficBlockPopup', {
        data: {
          affiliateId: this.id,
          affiliateEmail: this.info.email || '',
          isBlocked: this.isTrafficBlocked,
        },
        listeners: {
          saved: this.handleTrafficBlockSaved,
        },
      });
    },
    handleTrafficBlockSaved() {
      this.fetchAffiliateData({ isSilent: true });
    },
    getAffiliateActivity() {
      this.isDataLoading = true;
      this.$api
        .getAffiliateActivity({
          affiliate_id: this.id,
          limit: 3,
          offset: 0,
        })
        .then((response) => {
          this.activity = this.$_.cloneDeep(response.data.payload);
        })
        .finally(() => {
          this.isDataLoading = false;
          this.isPopoverDisabled();
        });
    },
    getAffiliateMonitoringInfo() {
      this.isDataLoading = true;
      this.$api
        .getAffiliateMonitoring({affiliate_id: this.id})
        .then((response) => {
          this.monitoringInfo = this.$_.cloneDeep(response.data.payload[0]);
        })
        .finally(() => {
          this.isDataLoading = false;
        });
    },
    pinAffiliateHandler(affiliate) {
      const pr = {
        referred_by: affiliate.referral_id,
      };
      this.$api
        .updateAffiliateReferral(this.id, pr)
        .then(() => {
          this.fetchAffiliateData();
          this.isPinOpen = false;
          this.cbAction({});
        })
        .catch((e) => {
          this.cbAction(e.data.errors);
        });
    },
    handleIntroducedCommand(command) {
      switch (command) {
      case 'open':
        this.$router.push({
          path: `/affiliates/${this.info.referred_by_info.id}/info`,
        });
        break;
      default:
        break;
      }
    },
    introducedPin() {
      this.isPinOpen = true;
    },
    handlePayment() {
      this.$api
        .createPaymentAffiliate(this.id)
        .then((response) => {
          this.infoCreatePayment = response.data.payload;
          if (this.infoCreatePayment.payment_created) {
            this.confirmPayment(this.infoCreatePayment.payment_created);
          } else {
            this.confirmPayment(this.infoCreatePayment.payment_created);
          }
        });
    },
    onConfirm() {
      // this.isConfirmOpen = false;
      switch (this.confirmAction) {
      case 'Pin':
        this.pinAffiliateHandler(this.targetAffiliate);
        this.$refs.confirm.close();
        break;
      case 'editBls':
        this.changeBalance();
        this.$refs.confirm.close();
        break;
      case 'confirmPayment':
        this.$refs.confirm.close();
        this.fetchAffiliateData();
        break;
      case 'createPayment':
        this.handlePayment();
        this.$refs.confirm.close();
        break;
      case 'Block':
        this.blockAffiliate();
        this.$refs.confirm.close();
        break;
      case 'Unblock':
        this.unblockAffiliate();
        this.$refs.confirm.close();
        break;
      case 'Approve':
        this.approve();
        this.$refs.confirm.close();
        break;
      case 'To Review':
        this.revoke();
        this.$refs.confirm.close();
        break;
      case 'Decline':
        this.decline();
        this.$refs.confirm.close();
        break;
      case 'Decline w/':
        this.declineNote();
        this.$refs.confirm.close();
        break;
      case 'Unpin':
        this.unpinAffiliate();
        this.$refs.confirm.close();
        break;
      case 'resetTotp':
        this.reset_totp();
        this.$refs.confirm.close();
        break;
      case 'askForKyc':
        this.askForKycRequest();
        this.$refs.confirm.close();
        break;
      case 'skipKyc':
        this.skipKycRequest();
        this.$refs.confirm.close();
        break;
      case 'stopMonitoring':
        this.stopMonitoring();
        this.$refs.confirm.close();
        break;
      case 'deletePublicProfile':
        this.deletePublicProfile().then(() => this.$refs.confirm.close());
        break;
      default:
        break;
      }
    },

    reset_totp() {
      this.$api
        .resetTotp(this.id)
        .then(() => {
          this.info.google2fa_enabled = false;
        });
    },
    askForKycRequest() {
      return this.$api.postAffiliateRequestKyc(this.id)
        .then(() => this.fetchAffiliateData({ isSilent: true }));
    },
    skipKycRequest() {
      return this.$api.postAffiliateSkipKyc(this.id)
        .then(() => this.fetchAffiliateData({ isSilent: true }));
    },
    stopMonitoring() {
      this.$api
        .deleteAffiliateMonitoring(this.monitoringInfo.id)
        .then(() => {
          this.monitoringInfo = null;
        });
    },
    unpinAffiliate() {
      const pr = {
        referred_by: null,
      };
      this.$api
        .updateAffiliateReferral(this.id, pr)
        .then(() => {
          this.fetchAffiliateData();
        });
    },
    confirmClose() {
      this.actionIcon = '';
      this.actionFaIcon = '';
    },
    confirmPayment(isCreated) {
      if (isCreated) {
        this.confirmAction = 'confirmPayment';
        this.confirmTitle = `${this.$t('affiliates.confirm.title_9')}`;
        this.confirmMsg = `${this.$t('affiliates.confirm.msg_9')}`;
        this.actionName = `${this.$t('affiliates.confirm.action_9')}`;
        this.confirmType = 'success';
        this.confirmDangerButton = false;
        this.$refs.confirm.open();
      } else {
        this.confirmAction = 'confirmPayment';
        this.confirmTitle = `${this.$t('affiliates.confirm.title_10')}`;
        this.actionName = `${this.$t('affiliates.confirm.action_10')}`;
        this.confirmType = 'warning';
        this.actionFaIcon = 'check';
        this.confirmDangerButton = false;
        this.$refs.confirm.open();

        switch (this.infoCreatePayment.fail_reason) {
        case 'AFFILIATE_ACCOUNT_STATUS_IS_NOT_SUITABLE_ERROR':
        case 'AFFILIATE_HAS_NO_WALLET_ERROR':
        case 'AMOUNT_LOWER_THAN_MINIMUM_PAYMENT_ERROR':
        case 'AFFILIATE_PAYMENTS_DISABLED_ERROR':
        case 'SITE_PAYMENT_METHOD_IS_DISABLED_ERROR':
          this.confirmMsg = `${this.$t(`affiliates.confirm.${this.infoCreatePayment.fail_reason}`)}`;
          break;
        case 'PAYMENT_CANNOT_BE_CREATED_EARLIER_ERROR':
          this.confirmMsg = `${this.$t(`affiliates.confirm.${this.infoCreatePayment.fail_reason}`)} <span>${format(this.infoCreatePayment.next_payment_min_timestamp, 'yyyy-MM-dd HH:mm:ss', { locale: locales[this.$i18n.locale] })}</span>`;
          break;
        default:
          break;
        }
      }
    },
    resetTotp() {
      this.confirmAction = 'resetTotp';
      this.confirmMsg = `${this.$t('affiliates.confirm.resetTotp_text', { name: this.info.email })}`;
      this.actionName = `${this.$t('affiliates.confirm.resetTotp_action')}`;
      this.confirmTitle = `${this.$t('affiliates.confirm.resetTotp_title')}`;
      this.confirmType = 'success';
      this.actionFaIcon = 'shield-check';
      this.$refs.confirm.open();
    },
    deleteNote(note) {
      this.confirmAction = 'deleteNote';
      this.confirmTitle = `${this.$t('affiliates.confirm.delete_note_title')}`;
      this.confirmMsg = `${this.$t('affiliates.confirm.delete_note_text')}`;
      this.actionName = `${this.$t('affiliates.confirm.delete_note_action')}`;
      this.confirmType = 'warning';
      this.actionFaIcon = 'trash-alt';
      this.confirmData = note;
      this.$refs.confirm.open();
    },
    createPayment() {
      this.$eventBus.$emit('open-popup', 'CreatePaymentPopup', {
        data: {
          affiliateId: this.id,
          affiliateEmail: this.info.email || '',
          canCreateInternal: this.canCreateInternalPayment,
          canCreateExternal: this.canCreateExternalPayment,
        },
        listeners: {
          success: this.handleCreatePaymentSuccess,
        },
      });
    },
    handleCreatePaymentSuccess(payload) {
      if (payload) {
        this.infoCreatePayment = payload;
        this.confirmPayment(payload.payment_created);
        return;
      }

      this.infoCreatePayment = { payment_created: true };
      this.confirmPayment(true);
    },
    askForKycHandler() {
      if (this.isKycActionDisabled) return;

      this.confirmAction = 'askForKyc';
      this.confirmMsg = `${this.$t('affiliates.confirm.ask_kyc_text', { affiliateEmail: this.info.email })}`;
      this.actionName = `${this.$t('affiliates.confirm.ask_kyc_action')}`;
      this.confirmTitle = `${this.$t('affiliates.confirm.ask_kyc_title')}`;
      this.confirmType = 'success';
      this.actionFaIcon = 'address-card';
      this.$refs.confirm.open();
    },
    skipKycHandler() {
      this.confirmAction = 'skipKyc';
      this.confirmMsg = `${this.$t('affiliates.confirm.skip_kyc_text', { affiliateEmail: this.info.email })}`;
      this.actionName = `${this.$t('affiliates.confirm.skip_kyc_action')}`;
      this.confirmTitle = `${this.$t('affiliates.confirm.skip_kyc_title')}`;
      this.confirmType = 'success';
      this.actionFaIcon = 'arrow-right-long-to-line';
      this.$refs.confirm.open();
    },
    introducedUnpin() {
      this.confirmAction = 'Unpin';
      this.confirmMsg = `${this.$t('affiliates.confirm.msg_6', { refferedEmail: this.info.referred_by_info.email })}`;
      this.actionName = `${this.$t('affiliates.confirm.action_6')}`;
      this.confirmTitle = `${this.$t('affiliates.confirm.title_6', { refferedEmail: this.info.referred_by_info.email })}`;
      this.confirmType = 'warning';
      this.actionFaIcon = 'unlink';
      this.$refs.confirm.open();
    },

    blockAffiliateHandler() {
      this.confirmAction = 'Block';
      this.confirmMsg = `${this.$t('affiliates.affiliatesInfo.blockText', { affiliateEmail: this.info.email })}`;
      this.actionName = `${this.$t('affiliates.affiliatesInfo.block_action')}`;
      this.confirmTitle = `${this.$t('affiliates.affiliatesInfo.block_title', { affiliateEmail: this.info.email })}`;
      this.confirmType = 'warning';
      this.actionFaIcon = 'lock';
      this.$refs.confirm.open();
    },
    unblockAffiliateHandler() {
      this.confirmAction = 'Unblock';
      this.confirmMsg = `${this.$t('affiliates.affiliatesInfo.unblockText', { affiliateEmail: this.info.email })}`;
      this.actionName = `${this.$t('affiliates.affiliatesInfo.unblock_action')}`;
      this.confirmTitle = `${this.$t('affiliates.affiliatesInfo.unblock_title', { affiliateEmail: this.info.email })}`;
      this.confirmType = 'success';
      this.actionFaIcon = 'unlock';
      this.$refs.confirm.open();
    },
    approveAffiliateHandler() {
      this.confirmAction = 'Approve';
      this.confirmTitle = `${this.$t('affiliates.affiliatesInfo.approve_title', { affiliateEmail: this.info.email })}`;
      this.confirmMsg = `${this.$t('affiliates.affiliatesInfo.approveText', { affiliateEmail: this.info.email })}`;
      this.actionName = `${this.$t('affiliates.affiliatesInfo.approve_action')}`;
      this.confirmType = 'success';
      this.actionFaIcon = 'check';
      this.$refs.confirm.open();
    },
    revokeAffiliateHandler() {
      this.confirmAction = 'To Review';
      this.confirmTitle = `${this.$t('affiliates.affiliatesInfo.review_title', { affiliateEmail: this.info.email })}`;
      this.confirmMsg = `${this.$t('affiliates.affiliatesInfo.toReviewText', { affiliateEmail: this.info.email })}`;
      this.actionName = `${this.$t('affiliates.affiliatesInfo.review_action')}`;
      this.confirmType = 'success';
      this.actionFaIcon = 'check';
      this.$refs.confirm.open();
    },
    declineAffiliateHandler(w) {
      this.confirmAction = `Decline${w ? ' w/' : ''}`;
      this.confirmMsg = w ? `${this.$t('affiliates.affiliatesInfo.declineAndNotifyText', { affiliateEmail: this.info.email })}` : `${this.$t('affiliates.affiliatesInfo.declineText', { affiliateEmail: this.info.email })}`;
      this.actionName = w ? this.$t('affiliates.affiliatesInfo.decline_and_notify') : `${this.$t('affiliates.affiliatesInfo.decline')}`;
      this.confirmTitle = w ? `${this.$t('affiliates.confirm.title_8_1', { affiliateEmail: this.info.email })}` : `${this.$t('affiliates.confirm.title_8_2', { affiliateEmail: this.info.email })}`;
      this.confirmType = 'warning';
      this.actionFaIcon = w ? 'bell' : 'check';
      this.$refs.confirm.open();
    },
    blockAffiliate() {
      this.$api
        .blockAffiliate(this.id)
        .then(() => {
          this.fetchAffiliateData();
        });
    },
    unblockAffiliate() {
      this.$api
        .unblockAffiliate(this.id)
        .then(() => {
          this.fetchAffiliateData();
        });
    },
    resetPasswordAffiliate() {
      this.isResetOpen = true;
    },
    activateAffiliateHandler() {
      this.$api
        .activateAffiliate(this.id)
        .then(() => {
          this.fetchAffiliateData();
          this.$eventBus.$emit('notify-event', {
            type: 'info',
            text: this.$t('affiliates.confirm.aff_email_success'),
          });
        })
        .catch(() => {
          this.$eventBus.$emit('notify-event', {
            type: 'info',
            text: this.$t('affiliates.confirm.aff_email_fail'),
          });
        });
    },

    editReportingSettings() {
      this.editReporting = true;
      this.errors = {};
      this.infoDump = this.$_.cloneDeep(this.info);
    },
    addAffiliatePromoCodeLevel() {
      const current = this.limits.max_promo_codes_levels || [];
      const last = current[current.length - 1] || { ftd_count: 0, max_amount: 0 };
      const nextFtd = +last.ftd_count || 0;

      this.limits.max_promo_codes_levels = [
        ...current,
        {
          ftd_count: current.length ? nextFtd + 1 : 0,
          max_amount: 0,
        },
      ];
    },
    removeAffiliatePromoCodeLevel(index) {
      if (index === 0 && this.limits.max_promo_codes_levels.length > 1) {
        return;
      }

      this.limits.max_promo_codes_levels = (this.limits.max_promo_codes_levels || []).filter((_, i) => i !== index);
    },
    preventLimitsSymbol(e) {
      if (e && e.preventDefault && !(/^[0-9]*\.?[0-9]*$/).test(e.key) && ![8, 46].includes(e.keyCode)) {
        e.preventDefault();
      }
    },

    cancelLimits() {
      this.errors = {};
      this.fetchAffiliateData();
    },
    saveLimits() {
      const localLimits = this.$_.cloneDeep(this.limits);
      Object.keys(localLimits).forEach((key) => {
        if (localLimits[key] === '' || localLimits[key] === 'default') {
          localLimits[key] = null;
        }
      });

      if (!localLimits.max_promo_codes_levels?.length) {
        localLimits.max_promo_codes_levels = null;
      }

      if(localLimits.allow_promo_code_create_or_edit !== null) {
        localLimits.allow_promo_code_create_or_edit = localLimits.allow_promo_code_create_or_edit === 'true';
      }

      this.$api
        .updateAffiliateLimits(this.id, localLimits)
        .then(() => {
          this.$refs.confirmEditLimits.close();
        })
        .catch((error) => {
          this.errors = this.$_.cloneDeepWith(error.data.errors);
        });
    },
    cancelPayment() {
      this.errors = {};
      this.payment.reason = '';
      this.fetchAffiliateData();
    },
    savePayment() {
      this.payment.site_payment_method_id = this.payment.site_payment_method_id ? this.payment.site_payment_method_id : null;
      this.$api
        .updateAffiliatePayment(this.id, this.payment)
        .then(() => {
          this.payment.reason = '';
          this.$refs.confirmEditPayment.close();
          this.$refs.notesRef.getNotes(this.id);
        })
        .catch((error) => {
          this.errors = this.$_.cloneDeepWith(error.data.errors);
        });
    },
    saveCurrency() {
      this.$api.postAffiliateSwitchWallet({ affiliate_id: this.id, currency_code: this.currentCurrency })
        .then(() => {
          this.fetchWallets();
          this.fetchAvailableCurrencies();
          this.$refs.editCurrency.close();
        });
    },

    cancelNotificationsStatus() {
      this.errors = {};
      this.fetchAffiliateData();
    },
    saveNotificationsStatus() {
      this.$api.updateAffiliateNotificationsSettings(this.id, this.notification).then(() => {
        this.$refs.changeNotificationsStatus.close();
      })
        .catch((error) => {
          this.errors = this.$_.cloneDeepWith(error.data.errors);
        });
    },

    cancelEdit(setting) {
      this.$emit('update:info', this.$_.cloneDeep(this.infoDump));
      if (setting === 'mediaBuying') {
        this.editBuying = false;
        this.mediaBuying.media_buying_enabled = this.info.media_buying_enabled;
      } else {
        this.editReporting = false;
        [
          this.reports.cpa_profit_viewable,
          this.reports.referred_cpa_profit_viewable,
          this.reports.revshare_profit_viewable,
          this.reports.referred_revshare_profit_viewable,
        ] = [
          this.info.cpa_profit_viewable,
          this.info.referred_cpa_profit_viewable,
          this.info.revshare_profit_viewable,
          this.info.referred_revshare_profit_viewable,
        ];
      }
      this.errors = {};
    },
    saveEdit(/* setting */) {
      // if (setting === 'mediaBuying') {
      //   this.editBuying = false;
      //   this.updateMediaBuyingOptions();
      // } else {
      this.editReporting = false;
      this.updateReportingOptions();
      // }
    },

    declineNote() {
      this.$api
        .rejectAffiliate(this.id, true)
        .then(() => {
          this.fetchAffiliateData();
        });
    },
    decline() {
      this.$api
        .rejectAffiliate(this.id, false)
        .then(() => {
          this.fetchAffiliateData();
        });
    },
    approve() {
      this.$api
        .approveAffiliate(this.id, this.payment)
        .then(() => {
          this.$store.commit(`nav/${NAV_SET_SUB_VIEW}`, 'list');
          this.fetchAffiliateData();
        })
        .catch((error) => {
          this.errors = this.$_.cloneDeepWith(error.data.errors);
        });
    },
    revoke() {
      this.$api
        .revokeAffiliate(this.id)
        .then(() => {
          this.$store.commit(`nav/${NAV_SET_SUB_VIEW}`, 'review');
          this.fetchAffiliateData();
        })
        .catch((error) => {
          this.errors = this.$_.cloneDeepWith(error.data.errors);
        });
    },

    returnAffiliateInfo() {
      this.errors = {};
      this.fetchAffiliateData();
    },


    cancelInfo() {
      this.returnAffiliateInfo();
    },
    saveInfo() {
      if (this.popupInfo.date_of_birth) {
        this.popupInfo.date_of_birth = format(this.popupInfo.date_of_birth, 'yyyy-MM-dd');
      } else {
        this.popupInfo = this.$_.omit(this.popupInfo, 'date_of_birth');
      }
      this.$api
        .putAffiliateInfo(this.id, this.popupInfo)
        .then((response) => {
          if (this.confirmAction === 'Approve') {
            this.$store.commit(`nav/${NAV_SET_SUB_VIEW}`, 'list');
          }
          this.$emit('update:info', this.$_.cloneDeepWith(response.data.payload));
          this.$refs.confirmEditInfo.close();
        })
        .catch((error) => {
          this.errors = this.$_.cloneDeepWith(error.data.errors);
        });
    },

    cancelSiteUrl() {
      this.returnAffiliateInfo();
    },

    savelSiteUrl() {
      this.$api.putAffiliateInfo(this.id, this.popupInfo).then((response) => {
        this.$emit('update:info', this.$_.cloneDeepWith(response.data.payload));
        this.$refs.editSiteUrl.close();
      })
        .catch((error) => {
          this.errors = this.$_.cloneDeepWith(error.data.errors);
        });
    },

    showBalanceHistory() {
      this.$router.push({
        path: `/affiliates/${this.id}/balance-history/${this.wallets.id}`,
      });
    },
    humanizePaymentMethod(value) {
      const pm = this.paymentMethods.find((el) => {
        if (el.id === value) {
          return true;
        }
        return false;
      });
      return pm ? pm.name : false;
    },
    updateReportingOptions() {
      return this.$api
        .updateAffiliatReportingOptions(this.id, this.reports).then(() => {
          this.fetchAffiliateData();
        });
    },
    // updateMediaBuyingOptions() {
    //   return this.$api
    //     .updateAffiliatMediaBuyingOptions(this.id, this.mediaBuying).then(() => {
    //       this.fetchAffiliateData();
    //     });
    // },
  },
};
</script>

<style lang="scss" scoped>
.no-public-profile {
  font-size: 16px;
  line-height: 1.25;
  text-align: center;
  color: #a6b2c4;
  padding: 16px 0;
}

.affiliate-info {
  :deep(.ui-confirm .body) {
    max-height: 70vh;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .edit-balance.ui-input {
    // /deep/
    :deep(.input-post-text) {
      font-size: 13px;
      margin-left: 4px;
      margin-right: 8px;
    }
  }

  padding-bottom: 12px;

  .confirm-edit-payment {
    .body__wrap {
      display: block;
    }

    .promo-codes-levels {
      padding: 10px;
      border-radius: 8px;
      background-color: #f0f2f5;

      &__input {
        flex: 1 1 0;
        min-width: 0;

        &_readonly {
          cursor: not-allowed;

          :deep(.input-element) {
            cursor: not-allowed;
          }
        }

        :deep(.input-pre-icon) {
          font-weight: 500 !important;
        }

        :deep(.input-post-text) {
          font-size: 13px;
        }
      }

      &__divider {
        margin-top: 0;
        margin-bottom: 0;
        border: 0;
        height: 2px;
        width: 10px;
        background-color: #d3d3d3;
      }
    }
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    //width: 90%;
    //min-width: 1140px;

    .card-content {
      .values {
        margin-left: 8px;
        text-wrap: nowrap;
      }

      .social-link {
        color: inherit;
        text-decoration: none;
      }

      .field {
        padding: 8px 0;

        .label, .value {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          line-height: normal;
          text-wrap-mode: wrap;
        }

        &.misc {
          white-space: pre-line;
        }
      }

      .max-promo-levels-row {
        padding: 0 0 0 8px;
        flex-direction: column;
      }

      .max-promo-level-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 0;
        width: 100%;

        .less-or-equal {
          font-size: 12px;
          font-weight: 300 !important;
        }

        & + .max-promo-level-row {
          border-top: 1px solid #e5e5e5;
        }
      }
    }

    .personal-info {
      .card-content {
        .label {
          white-space: nowrap;
        }

        .values {
          display: block;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin-left: 8px;
          line-height: 1.1;
        }
      }
    }

    .select-wrap .select-block .label {
      padding-bottom: 0;
    }

    .toolbar {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eaeaea;
      padding: 12px 0;
      .btns {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        row-gap: 8px;

        .login-link {
          color: inherit;
          user-select: none;
          text-decoration: none;
        }
        .action-btn {
          margin-right: 8px;
          flex: 1 1 auto;
        }
      }
      &.tools {
        justify-content: flex-start;
        .btns {
          .action-btn,
          .login-link {
            flex: 0 0 auto;
          }
        }
      }
    }
    .info {
      padding-top: 16px;
      display: flex;
      justify-content: space-between;
      .select,
      .input {
        width: 260px;
      }
      .sidebar {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        margin-right: 30px;
        width: 275px;
        min-width: 275px;
        .block {
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          width: 100%;
          padding: 16px 0 24px;
          .payment-head {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
            .block-title {
              font-size: 20px;
            }
          }
          &:not(:last-of-type) {
            border-bottom: 1px solid #eaeaea;
          }
          .sub-block {
            width: 100%;
            display: flex;
            align-items: flex-start;
            flex-direction: column;
            &:not(:last-child) {
              margin-bottom: 16px;
            }
            .label {
              font-size: 14px;
              font-weight: 500;
              text-transform: uppercase;
              margin-bottom: 4px;
            }
            .value {
              font-size: 14px;
            }
            &.balance {
              cursor: pointer;
              .label {
                margin-bottom: 0;
                margin-top: 4px;
              }
              .value {
                font-size: 36px;
                color: #20815e;
                &.negative {
                  color: #d26370;
                }
              }
            }
          }
        }
      }
    }
  }

  .body {
    flex-grow: 10;
    display: flex;
    &-info{
      min-width: 556px;
      width: 100%;
      max-width: 60vw;
      margin-right: 30px;
    }
  }
}

</style>
